import React, { useState, useEffect, useRef } from "react";
import { Dialog, Dropdown, Calendar, AutoComplete, Image, Avatar } from "primereact";
import { useFormik } from "formik";
import { DataStore, SortDirection, Storage, Predicates } from "aws-amplify";
import { toast } from "react-toastify";
import moment from "moment";
import { Sidebar } from "primereact/sidebar";
import { GetAWSObjectURL, UploadFileOnS3, GetAWSObjectDelete } from "../../helper/aws";
import { handleNotificationsOnStatusChangeforPSA } from "../../components/actions/notficationActions";

import { TabView, TabPanel } from "primereact/tabview";
import PsaTermsAndConditions from "../../components/personalserivicet&c";
import w9DetailesPic from "../../assets/svg/w9details.svg";
import { ConvertResponseForSelect, graphQLGetAllData, graphQLFindRecordById, removeDuplicateApprover } from '../../helper/commonfunctions';
import PsaPdf from "../../components/reportpdftemplate/personalserviceagreementpdf";
import empDetailsImg from "../../assets/images/applicationImg.png";
import { USER_TYPES, USER_TYPES_NAMES, PSA_Status, BUSINESS_ENTITY, PSA_Designation } from "../../helper/enum";
import { reactLocalStorage } from "reactjs-localstorage";
import AWS from "aws-sdk";
import awsmobile from "../../aws-exports";
import { Request_Status } from "../../helper/enum";
import { SendNotificationEmail } from "../../helper/mail";
import PdfForm from "../../components/reportpdftemplate/PdfForm";
import { Button } from "primereact/button";
import { getBottomNavigationUtilityClass } from "@mui/material";
import { Margin, usePDF } from "react-to-pdf";
import { PropertiesIcon, TrendingUpIcon } from "evergreen-ui";
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../graphql/mutations';
import * as queries from "../../graphql/queries";
import { Loader } from "@aws-amplify/ui-react";
const PersonalsServiceagreementModal = ({
  iSCopyForm,
  setISCopyForm,
  showNextPopUp,
  setAddSignature,
  setShowNextPopUp,
  setShowPreviewPopUp,
  showPreviewPopUp,
  psaconsultantData,
  setPsaconsultantData,
  empCodeList,
  superAdminEditor,
  schoolList,
  srcReportIdPsa,
  formData,
  setFormData,
  setIsMasterDataLoaded,
  visibleCreteReportPopup,
  setVisibleCreteReportPopup,
  visibleEdit,
  setVisibleEdit,
  isEdit,
  setIsEdit,
  pSAPartyData,
  setPSAPartyData,
  isApproverEdit,
  setIsApproverEdit,
  routingData,
  setRoutingData,
  BindList,
  getMasterData,
  setActiveIndex,
  imEdit,
  psaPdfUpdate,
  setIsPsaPdfUpdate,
  budgetClerkDisabled,
  budgetManagerDisabled,
  executiveApproverDisabled,
  hrExecutiveSecretaryDisabled,
  psaCunsultentDisable
}) => {

  console.log("budgetClerkDisabledModal",budgetClerkDisabled);




  const [basicInfoPopUp, SetBasicInfoPopUp] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [partyDetailesPopup, setPartyDetailesPopUp] = useState(false);
  const [budgetClerk, setBudgetClerk] = useState(null);
  const [hrConsultant, setHrConsultant] = useState(null);
  const [executiveApprover, setExecutiveApprover] = useState(null);
  const [hrSecreatary, setHrSecreatary] = useState(null);
  const [attchmentAndDetailes, SetAttchmentAndDetailes] = useState(false);
  const [termsAndConditions, SetTermsAndConditions] = useState(false);
  const [eddDetailes, SetEddDetailes] = useState(false);
  const [w9Detailes, SetW9Detailes] = useState(false);
  const [loaderPdf, setLoaderPdf] = useState(false);
  const [previewAndEdit, SetPreviewAndEdit] = useState(false);
  const [confirmVisible2, setConfirmVisible2] = useState(false);
  const [items, setItems] = useState([]);
  const [allApproverList, setAllApproverList] = useState([]);
  const [inputValueBox, setInputValueBox] = useState("0");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedEmployeeDetails, setSelectedEmployeeDetails] = useState(null);
  const [selectedFirstApprover, setSelectedFirstApprover] = useState("");
  const [secondApproverList, setSecondApproverList] = useState([]);
  const [thirdApproverList, setThirdApproverList] = useState([]);
  const [selectedThirdApprover, setSelectedThirdApprover] = useState(null);
  const [firstApproverList, setFirstApproverList] = useState([]);
  const [payrollList, setPayrollList] = useState([]);
  const [selectedSecondApprover, setSelectedSecondApprover] = useState(null);
  const [selectedPayroll, setSelectedPayroll] = useState(null);
  const [selectedBudgetManagerApprover, setSelectedBudgetManagerApprover] = useState(null);
  const loggedUserId = reactLocalStorage.get("loggedUserId");
  const [userData, setUserData] = useState([]);
  const [fileName, setFileName] = useState([]);
  const [effectiveDate, setEffectiveDate] = useState();
  const [initiatorDocuments, setInitiatorDocuments] = useState([]);
  const [expirationDate, setExpirationDate] = useState()
  const [partyDocuments, setPartyDocuments] = useState([]);
  const [expirationDisabled, setExpirationDisabled] = useState(true);

  // PSA Consultant's Details
  const [party, setParty] = useState();
  const [pocName, setPocName] = useState();
  const [psaEmail, setPsaEmail] = useState();
  const [employerID, setEmployerID] = useState();
  const [clientId, setClientId] = useState();
  const [pocNumber, setPocNumber] = useState();
  const [ssn, setSsn] = useState();
  const childRef = useRef();

  // Date Validation
  const validateDate = (event) => {
    const inputValue = event.target.value;

    // Define a regular expression pattern for a valid date (YYYY-MM-DD)
    const validDateFormat = /^\d{4}-\d{2}-\d{2}$/;

    if (!validDateFormat.test(inputValue)) {
      // If the input doesn't match the valid date format, clear the input value
      event.target.value = '';
    }
  };

  const handleEffectiveDateChange = (e) => {
    setExpirationDisabled(false);
  };


  const saveBtnRef = useRef(null);

  const { toPDF, targetRef } = usePDF({
    method: "save",
    filename: "GUSD New Service Agreement.pdf",
    page: { margin: Margin.MEDIUM }
  });
  async function setApproverList(e) {
    try {
      // var employeeResponses = await DataStore.query(Employee, Predicates.ALL, {
      // sort: s => s.employee_name(SortDirection.ASCENDING)
      // });
      //graphql 
      var employeeResponses = await graphQLGetAllData("listEmployees")
      employeeResponses = employeeResponses.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));



      if (employeeResponses !== null) {
        let employeeDatas = employeeResponses.filter(item => item._deleted !== true);;
        const employeeData = removeDuplicateApprover(employeeDatas);

        let employee = [];
        employeeData.map(item => {
          let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
          let obj = {
            name: name,
            code: item.user_Id
          };
          employee.push(obj);
        });

        console.log("employee", employee);
        if (e) {
          let employeeSearchData = [];
          employeeSearchData = employee.filter(item => item.employee_code === e.target.value);
          employeeSearchData = employee.filter(item => item.employee_name === e.target.value);
          setAllApproverList(employee);
        } else {
          setAllApproverList(employee);
        }

      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    setApproverList();
    if (imEdit) {
      getRoutingData(formData);
    }
  }, [formData]);

  useEffect(() => {
    if (psaconsultantData?.id && imEdit) {

      const getPSADocuments = () => {
        return new Promise(async (resolve, reject) => {

          // let PSADocumentsData = await DataStore.query(PSADocuments, c => c?.reportId.eq(psaconsultantData?.id), {
          // sort: s => s.createdAt(SortDirection.ASCENDING)
          // });

          let PSADocumentsData = await graphQLGetAllData("listPSADocuments", [{ reportId: { eq: psaconsultantData?.id } }])
          PSADocumentsData = PSADocumentsData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
          resolve(PSADocumentsData);
        });
      };

      getPSADocuments().then(res => {
        setInitiatorDocuments(res);

      });

      //PSAPARTY files
      const getPSAPartyDocuments = () => {
        return new Promise(async (resolve, reject) => {

          // let PSAPartyDocumentsData = await DataStore.query(PSAPartyDocument, c => c?.reportId.eq(psaconsultantData?.id), {
          // sort: s => s.createdAt(SortDirection.ASCENDING)
          // });
          let PSAPartyDocumentsData = await graphQLGetAllData("listPSAPartyDocument", [{ reportId: { eq: psaconsultantData?.id } }])
          PSAPartyDocumentsData = PSAPartyDocumentsData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

          resolve(PSAPartyDocumentsData);
        });
      };

      getPSAPartyDocuments().then(res => {

        setPartyDocuments(res);
      });
    }
  }, [psaconsultantData?.id, isEdit]);


  const getRoutingData = async formData => {
    // setSelectedFirstApprover("");	
    // setSelectedSecondApprover("")
    // setSelectedThirdApprover("")
    // setSelectedPayroll("");

    if (formData.budgetClerk) {
      //let empName = await DataStore.query(Employee, c => c.user_Id.eq(formData.budgetClerk));
      let empName = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: formData.budgetClerk } }])

      let name = empName[0]?.employee_code
        ? `${empName[0]?.employee_name} (${empName[0].employee_code})`
        : empName[0].employee_name;

      let obj = { name: name, code: formData.budgetClerk };
      setSelectedFirstApprover(obj);
    }

    if (formData.budgetManager) {
      //let empName = await DataStore.query(Employee, c => c.user_Id.eq(formData.budgetManager));

      let empName = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: formData.budgetManager } }])

      let name = empName[0]?.employee_code
        ? `${empName[0].employee_name} (${empName[0].employee_code})`
        : empName[0].employee_name;

      let obj = { name: name, code: formData.budgetManager };
      setSelectedBudgetManagerApprover(obj);
    }

    if (formData.hrConsultant) {
      //let empName = await DataStore.query(Employee, c => c.user_Id.eq(formData.hrConsultant));
      let empName = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: formData.hrConsultant } }])
      let name = empName[0]?.employee_code
        ? `${empName[0]?.employee_name} (${empName[0]?.employee_code})`
        : empName[0]?.employee_name;

      let obj = { name: name, code: formData.hrConsultant };
      setSelectedSecondApprover(obj);
    }

    if (formData.executive) {
      //let empName = await DataStore.query(Employee, c => c.user_Id.eq(formData.executive));
      let empName = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: formData.executive } }])
      let name = empName[0]?.employee_code
        ? `${empName[0]?.employee_name} (${empName[0]?.employee_code})`
        : empName[0]?.employee_name;

      let obj = { name: name, code: formData.executive };
      setSelectedThirdApprover(obj);
    }

    if (formData.hrexecutive) {
      //let empName = await DataStore.query(Employee, c => c.user_Id.eq(formData.hrexecutive));
      let empName = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: formData.hrexecutive } }])
      let name = empName[0]?.employee_code
        ? `${empName[0]?.employee_name} (${empName[0]?.employee_code})`
        : empName[0]?.employee_name;

      let obj = { name: name, code: formData.hrexecutive };
      setSelectedPayroll(obj);
    }
  };

  const BasicInfoValidation = formData => {
    if (!formData?.assignmentTitle) {
      toast.error("Please Enter Assignment Title");
      return false;
    } else if (!formData?.department) {
      toast.error("Please Enter Department");
      return false;
    } else if (!formData?.agreementDate) {
      toast.error("Please Enter Agreement Date");
      return false;
    } else if (!formData?.amount) {
      toast.error("Please Enter Amount");
      return false;
    } else if (!formData?.effectiveDate) {
      toast.error("Please Enter Effective Date");
      return false;
    } else if (!formData?.expireDate) {
      toast.error("Please Enter Expire Date");
      return false;
    } else if (!formData?.accountNo) {
      toast.error("Please Enter Account No.");
      return false;
    } else if (!formData?.dateofboard) {
      toast.error("Please Enter Date Of Board Meeting");
      return false;
    } else if (!formData?.psaEmail) {
      toast.error("Please Enter PSA Consultant Email");
      return false;
    } else {
      return true;
    }
  };

  const routingValidation = formData => {
    // if (!selectedSecondApprover && eddDetailes === true) {
    //!formData?.hrConsultant?.code ||
    //toast.error("Please Enter HR Consultant Clearance Verification");
    // return false;
    // } else 

    if (!selectedThirdApprover && eddDetailes === true) {
      //!formData?.executive?.code ||
      toast.error("Please Enter Executive Approver");
      return false;
    } else if (!selectedPayroll && eddDetailes === true) {
      //!formData?.hrexecutive?.code ||
      toast.error("Please Enter HR Executive Secretary");
      return false;
    }

    if (selectedFirstApprover != '') {
      if (!selectedBudgetManagerApprover) {
        toast.error("Please Select Budget Manager");
        return false;
      }
    }

    //if (!selectedSecondApprover) {
    //!formData?.hrConsultant?.code ||
    //toast.error("Please Enter HR Consultant Clearance Verification");
    // return false;
    //} else 

    if (!selectedThirdApprover) {
      //!formData?.executive?.code ||
      toast.error("Please Enter Executive Approver");
      return false;
    } else if (!selectedPayroll) {
      //!formData?.hrexecutive?.code ||
      toast.error("Please Enter HR Executive Secretary");
      return false;
    } else {
      return true;
    }
  };

  const saveBasicInfo = async (type, formData) => {
    
    setBtnDisabled(true);

    //when Approver Edit skip the save/update
    // if (isApproverEdit) {
    //   toast.error("Approver can view only");
    //   setShowNextPopUp(false);
    //   return;
    // }
    // return
    // Basic Info

    if (type === "BasicInfo" || type === "submit" || type === "save") {
      if (!formData?.assignmentTitle) {
        saveBtnRef.current.disabled = false
        setBtnDisabled(false);
        toast.error("Please Enter Assignment Title");
        return;
      } else if (!formData?.department) {
        toast.error("Please Enter Department");
        setBtnDisabled(false);
        saveBtnRef.current.disabled = false
        return;
      } else if (!formData?.agreementDate) {
        toast.error("Please Enter Agreement Date");
        setBtnDisabled(false);
        saveBtnRef.current.disabled = false
        return;
      } else if (!formData?.amount) {
        toast.error("Please Enter Amount");
        setBtnDisabled(false);
        saveBtnRef.current.disabled = false
        return;
      } else if (!formData?.effectiveDate) {
        toast.error("Please Enter Effective Date");
        setBtnDisabled(false);
        saveBtnRef.current.disabled = false
        return;
      } else if (!formData?.expireDate) {
        toast.error("Please Enter Expire Date");
        setBtnDisabled(false);
        saveBtnRef.current.disabled = false
        return;
      } else if (!formData?.accountNo) {
        toast.error("Please Enter Account No.");
        setBtnDisabled(false);
        saveBtnRef.current.disabled = false
        return;
      } else if (!formData?.dateofboard) {
        toast.error("Please Enter Date Of Board Meeting");
        setBtnDisabled(false);
        saveBtnRef.current.disabled = false
        return;
      } else if (!formData?.psaEmail) {
        toast.error("Please Enter PSA Consultant Email");
        setBtnDisabled(false);
        saveBtnRef.current.disabled = false
        return;
      }
    }
    if (type === "save") {
      if (selectedFirstApprover != '') {
        if (!selectedBudgetManagerApprover) {
          saveBtnRef.current.disabled = false
          setBtnDisabled(false);
          toast.error("Please Select Budget Manager");
          return;
        }
      }

      if ((!formData?.hrConsultant?.code || !selectedSecondApprover) && eddDetailes === true) {
        //saveBtnRef.current.disabled = false
        //setBtnDisabled(false);
        // toast.error("Please Enter HR Consultant Clearance Verification");
        //return;
      } else if ((!formData?.executive?.code || !selectedThirdApprover) && eddDetailes === true) {
        saveBtnRef.current.disabled = false
        setBtnDisabled(false);
        toast.error("Please Enter Executive Approver");
        return;
      } else if ((!formData?.hrexecutive?.code || !selectedPayroll) && eddDetailes === true) {
        saveBtnRef.current.disabled = false
        setBtnDisabled(false);
        toast.error("Please Enter HR Executive Secretary");
        return;
      }
      // toast.success("Data Updated Successfully.");
    }

    if (type === "routing" || type === "submit") {

      if (selectedFirstApprover != '') {
        if (!selectedBudgetManagerApprover) {
          saveBtnRef.current.disabled = false
          toast.error("Please Select Budget Manager");
          return;
        }
      }
      if (!selectedSecondApprover) {
        //!formData?.hrConsultant?.code ||
        //saveBtnRef.current.disabled = false
        //toast.error("Please Enter HR Consultant Clearance Verification");
        //return;
      } else if (!selectedThirdApprover) {
        //!formData?.executive?.code ||
       
        saveBtnRef.current.disabled = false
        toast.error("Please Enter Executive Approver");
        return;
      } else if (!selectedPayroll) {
        //!formData?.hrexecutive?.code ||
        saveBtnRef.current.disabled = false
        toast.error("Please Enter HR Executive Secretary");
        return;
      }
    }

    if (isApproverEdit) {
      // toast.error("Approver can view only");
      if (isApproverEdit && type === "submit") {
        await updateData(formData);
        setShowNextPopUp(false);
        BindList();
        if(superAdminEditor){
        setActiveIndex(0);
        }else{
          setActiveIndex(1);
        }
        psaPdfUpdate(psaconsultantData?.id)
        setIsPsaPdfUpdate(true)
        return;
      } else {
        await updateData(formData);
        return;
      }
    }

    //check type
    if (type === "save" || type === "routing" || type === "BasicInfo") {

      if (iSCopyForm) {
        await saveData(formData);
      } else {

        if (!psaconsultantData?.id) await saveData(formData);
        else await updateData(formData);
      }
    } else if (type === "submit") {

      if (iSCopyForm) {
        psaconsultantData = {};
      }

      var newPSAReport = "";
      if (!psaconsultantData?.id) {


        newPSAReport = !psaconsultantData?.id ? await saveData(formData) : await updateData(formData);


        //transaction cycle start when submit without save condition
        if (newPSAReport) {

          // toast.success("Form Saved successfully");
          // const newPSATransactionCycle = await DataStore.save(
          // new PSATransactionCycle({
          // report_Id: newPSAReport.id,
          // from_Employee_Id: loggedUserId,
          // to_Employee_Id: "1", ///newPSAReport.budgetClerk,
          // status: PSA_Status.PENDING_FOR_APPROVAL_PSA_CONSULTANT, //PSA_Status.PENDING_FOR_APPROVAL_BUDGET_CLERK,  //"Open",
          // isApproved: false,
          // remark: "",
          // date: moment().format("YYYY-MM-DD"),
          // dateTime: moment().toISOString(), //new Date().toString()
          // designation: PSA_Designation.PSA_CONSULTANT
          // })
          // );

          //graphql 
          const newPSATransactionCycle = await API.graphql(
            graphqlOperation(mutations.createPSATransactionCycle, {
              input: {
                report_Id: newPSAReport.id,
                from_Employee_Id: loggedUserId,
                to_Employee_Id: "1",
                status: PSA_Status.PENDING_FOR_APPROVAL_PSA_CONSULTANT, //PSA_Status.PENDING_FOR_APPROVAL_BUDGET_CLERK,
                isApproved: false,
                remark: "",
                date: moment().format("YYYY-MM-DD"),
                dateTime: moment().toISOString(), //new Date().toString()
                designation: PSA_Designation.PSA_CONSULTANT
              }
            })
          );

        }
        // send mail to user
        let originUrl = window.location.origin + "/";
        let appLink = "<a href=" + originUrl + "psaconsultant/" + newPSAReport.id + " >PSA Consultant</a>";
        let message = `
        Dear ${newPSAReport.submittedTo ? newPSAReport.submittedTo : ''} 
        <br>
        <p>We are pleased to provide you with access to our Personnel Service Agreement (PSA) application for the purpose of entering your details and information securely. To facilitate this process, we are sending you a One-Time Password (OTP) along with a link to the Application Portal. Please follow the instructions below to complete the submission of your PSA details: </p>
        <br>
        <div>
        <h3>Instructions:</h3> 
        <br>
        <p>OTP: Your OTP is ${newPSAReport.otp}. Please keep this code confidential as it is for your use only. </p>
        <p>Application Portal Link: Click on the following link to access the Application Portal: ${appLink}. </p>
        <p>OTP Verification: Upon clicking the link, you will be prompted to enter the OTP code you received in this email. Enter the code and click "Verify OTP". </p>
        <p>PSA Details Submission: Once your OTP is verified, you will be directed to the PSA Consultant Information Submission form. Please complete all the required fields accurately. </p>
        <p>Upload Documents: If there are any supporting documents required, you can upload them within the application form. </p>
        <p>Review and Submit: Review all the information you've provided to ensure accuracy. Once you are satisfied, click the "Confirm" button. </p>
          <br>
        <p>NOTE: This is a system generated e-mail and please do not reply. If you encounter any technical issues or have questions regarding the submission process, please don't hesitate to contact our support team at [test@psa.com or 9876543210]. </p>
        <br>
        <p>DISCLAIMER: By using this OTP and accessing the Application Portal, you agree to the following terms: The OTP is confidential and should not be shared with anyone. Any information you submit through the Application Portal is accurate to the best of your knowledge. Misuse of the OTP or submission of false information may result in legal action or termination of the PSA. Please note that your submission will be subject to verification, and you may be contacted for additional information if necessary. </p>
        </div>
        `;
        // let message = `
        // Hello, ${newPSAReport.submittedTo ? newPSAReport.submittedTo : ''} </br>
        // <p>Please find your PSA Consultant form</p>
        // <h4>Your OTP is ${newPSAReport.otp}. </h4>`;
        // let originUrl = window.location.origin + "/";
        // message += "<a href=" + originUrl + "psaconsultant/" + newPSAReport.id + " >PSA Consultant</a>";
        SendNotificationEmail(newPSAReport.psaEmail, "OTP for Personnel Service Agreement (PSA) information submission", message);
        setConfirmVisible2(true);
        console.log("otp", newPSAReport.otp);
        console.log("otp--", appLink);

      } else {
        //update form data on submit
        newPSAReport = await updateData(formData);

        //const original = await DataStore.query(PSAConsultant, psaconsultantData.id);
        const original = await graphQLFindRecordById("getPSAConsultant", psaconsultantData.id);

        // send mail to user
        //---------------------------------------------
        let originUrl = window.location.origin + "/";
        let appLink = "<a href=" + originUrl + "psaconsultant/" + original.id + " >PSA Consultant</a>";
        let message = `
        Dear ${newPSAReport.submittedTo ? newPSAReport.submittedTo : ''} 
        <br>
        <p>We are pleased to provide you with access to our Personnel Service Agreement (PSA) application for the purpose of entering your details and information securely. To facilitate this process, we are sending you a One-Time Password (OTP) along with a link to the Application Portal. Please follow the instructions below to complete the submission of your PSA details: </p>
        <br>
        <div>
        <h3>Instructions:</h3> 
        <br>
        <p>OTP: Your OTP is ${newPSAReport.otp}. Please keep this code confidential as it is for your use only. </p>
        <p>Application Portal Link: Click on the following link to access the Application Portal: ${appLink}. </p>
        <p>OTP Verification: Upon clicking the link, you will be prompted to enter the OTP code you received in this email. Enter the code and click "Verify OTP". </p>
        <p>PSA Details Submission: Once your OTP is verified, you will be directed to the PSA Consultant Information Submission form. Please complete all the required fields accurately. </p>
        <p>Upload Documents: If there are any supporting documents required, you can upload them within the application form. </p>
        <p>Review and Submit: Review all the information you've provided to ensure accuracy. Once you are satisfied, click the "Confirm" button. </p>
        <br>
        <p>NOTE: This is a system generated e-mail and please do not reply. If you encounter any technical issues or have questions regarding the submission process, please don't hesitate to contact our support team at [test@psa.com or 9876543210]. </p>
        <br>
        <p>DISCLAIMER: By using this OTP and accessing the Application Portal, you agree to the following terms: The OTP is confidential and should not be shared with anyone. Any information you submit through the Application Portal is accurate to the best of your knowledge. Misuse of the OTP or submission of false information may result in legal action or termination of the PSA. Please note that your submission will be subject to verification, and you may be contacted for additional information if necessary. </p>
       
        </div>
        `;
        //---------------------------------------------
        // let originUrl = window.location.origin + "/";
        // let message = `
        // Hello, ${original.submittedTo ? original.submittedTo : ''} </br>
        // <p>Please find your PSA Consultant form</p>
        // <h4>Your OTP is ${original.otp}. </h4>`;

        // message += "<a href='" + originUrl + "psaconsultant/" + original.id + "' >PSA Consultant</a>";
        SendNotificationEmail(original.psaEmail, "OTP for Personnel Service Agreement (PSA) information submission", message);

        console.log("otp", newPSAReport.otp);
        console.log("otp--", appLink);
        //When report is rejected set review submit
        // const transactionCycle = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(psaconsultantData.id), {
        // sort: s => s.createdAt(SortDirection.ASCENDING)
        // });

        let transactionCycle = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: psaconsultantData.id } }])
        transactionCycle = transactionCycle.sort((b, a) => (a.createdAt).localeCompare(b.createdAt));

        let PSAConsultantTransactionCycleResponseLate =
          transactionCycle.length > 1 ? transactionCycle[original.length - 1] : transactionCycle[0];


        // await DataStore.save(
        // PSAConsultant.copyOf(original, updated => {
        // updated.status = Request_Status.S;
        // })
        // );
        //transaction cycle start when submit after save in edit condition
        //Update the case of review resubmitted to PSA consultant
        if (
          PSAConsultantTransactionCycleResponseLate &&
          PSAConsultantTransactionCycleResponseLate.status === PSA_Status.REJECTED 
         
        ) {
          // const addNewRowForRMReasponse = await DataStore.save(
          // new PSATransactionCycle({
          // report_Id: psaconsultantData.id,
          // from_Employee_Id: loggedUserId,
          // to_Employee_Id: '1',    ////psaconsultantData.budgetClerk,
          // status: PSA_Status.PENDING_FOR_APPROVAL_PSA_CONSULTANT,  ////PSA_Status.REVIEWDRESUBMITTED,
          // isApproved: false,
          // remark: "",
          // approver_level: "Initiator",
          // date: moment().format("YYYY-MM-DD"),
          // dateTime: moment().toISOString(),
          // designation: PSA_Designation.PSA_CONSULTANT
          // })
          // );
        


          const addNewRowForRMReasponse = await API.graphql(
            graphqlOperation(mutations.createPSATransactionCycle, {
              input: {
                report_Id: psaconsultantData.id,
                from_Employee_Id: loggedUserId,
                to_Employee_Id: '1',    ////psaconsultantData.budgetClerk,
                status: PSA_Status.PENDING_FOR_APPROVAL_PSA_CONSULTANT,  ////PSA_Status.REVIEWDRESUBMITTED,
                isApproved: false,
                remark: "",
                approver_level: "Initiator",
                date: moment().format("YYYY-MM-DD"),
                dateTime: moment().toISOString(),
                designation: PSA_Designation.PSA_CONSULTANT
              }
            })
          );


        } else {
          if (transactionCycle[0].status === "Rejected" || transactionCycle[0].status === "Pending for approval")  {
            

            if(superAdminEditor){
              await API.graphql({
                query: mutations.updatePSATransactionCycle,
                variables: {
                  input: {
                    id: transactionCycle[0].id,
                    _version: transactionCycle[0]._version,
                    isApproved: true,
                    to_Employee_Id: loggedUserId,
                    status : "Reviewed and Resubmit",
                    dateTime: moment().toISOString(),
                  }
                }
              });

            }else{
              await API.graphql({
                query: mutations.updatePSATransactionCycle,
                variables: {
                  input: {
                    id: transactionCycle[0].id,
                    _version: transactionCycle[0]._version,
                    isApproved: true,
                    status : "Reviewed and Resubmit",
                    dateTime: moment().toISOString(),
                  }
                }
              });

            }
            

            const addNewRowForRMReasponse = await API.graphql(
              graphqlOperation(mutations.createPSATransactionCycle, {
                input: {
                  report_Id: psaconsultantData.id,
                  from_Employee_Id: loggedUserId,
                  to_Employee_Id: "1", ///newPSAReport.budgetClerk,
                  status: PSA_Status.PENDING_FOR_APPROVAL_PSA_CONSULTANT, //PSA_Status.PENDING_FOR_APPROVAL_BUDGET_CLERK,  //"Open",
                  isApproved: false,
                  remark: "",
                  date: moment().format("YYYY-MM-DD"),
                  dateTime: moment().toISOString(), //new Date().toString()
                  designation: PSA_Designation.PSA_CONSULTANT
                }
              })
            );


          }

        }

        // toast.success("Form Saved successfully");


        if (original.status !== Request_Status.S) {
          // const newPSATransactionCycle = await DataStore.save(
          // new PSATransactionCycle({
          // report_Id: psaconsultantData.id,
          // from_Employee_Id: loggedUserId,
          // to_Employee_Id: original.budgetClerk,
          // status: "Open",
          // isApproved: false,
          // remark: "",
          // date: moment().format("YYYY-MM-DD")
          // })
          // );
        }
        setConfirmVisible2(true);
      }
      setFileName([]);
      setDocList([]);
      setInitiatorDocuments([])
      setPsaconsultantData([])
      setIsEdit(false);
      setSelectedFirstApprover("")
      setSelectedBudgetManagerApprover("");
      setSelectedSecondApprover("")
      setSelectedThirdApprover("")
      setSelectedPayroll("")
      setPSAPartyData([])
      // formik.resetForm()

      // formik.setFieldValue('items', []);
      //setPartyDocuments([])
    }
    saveBtnRef.current.disabled = false;
    // getRoutingData(formData)
    BindList();
    // getMasterData();
    saveBtnRef.current.disabled = false
    setBtnDisabled(false)
  };

  // const generatePDF = () => {

  //   const report = new JsPDF('portrait','pt','a3');
  //   report.html(document.querySelector('#pdfReport')).then(() => {
  //       report.save('GUSD New Service Agreement.pdf');
  //   });

  // }

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);

  const openCalendar = type => {
    if (inputRef2.current && type === "agreementDate") {
      inputRef2.current.focus();
    } else if (inputRef3.current && type === "effectiveDate") {
      inputRef3.current.focus();
    } else if (inputRef1.current && type === "expireDate") {
      inputRef1.current.focus();
    } else if (inputRef4.current && type === "dateofboard") {
      inputRef4.current.focus();
    } else if (inputRef5.current && type === "reviewDate") {
      inputRef5.current.focus();
    } else {
      console.log("error");
    }
  };

  const formik = useFormik({

    enableReinitialize: true,
    initialValues: {
      ...psaconsultantData,
      ...pSAPartyData,
      pSAPartyTypeBE: pSAPartyData?.typeBE,
      items: [{
        'assignmentTitle': '', 'department': '', 'amount': '', 'expireDate': '', 'notifyDays': '', 'accountNo': '', 'boardItem': '', 'submittedTo': '', 'referenceNo': '',
        'agreementDate': '', 'effectiveDate': '', 'reviewDate': '', 'services': '', 'dateofboard': '', 'pageItem': '', 'psaEmail': ''
      }],
      // submittedTo:
      //   userData.length > 0 &&
      //   userData.find(res => {
      //     if (res.code === psaconsultantData.submittedTo) {
      //       return res;
      //     }
      //   }),
      department:
        schoolList.length > 0 &&
        schoolList.find(res => {
          if (res.code === psaconsultantData?.department) {
            return res;
          }
        }),
      budgetClerk:
        routingData?.length > 0 &&
        routingData?.find(res => {
          if (res.code === psaconsultantData.budgetClerk) {
            return res;
          }
        }),

      budgetManager:
        routingData?.length > 0 &&
        routingData?.find(res => {
          if (res.code === psaconsultantData.budgetManager) {
            return res;
          }
        }),

      hrConsultant:
        routingData?.length > 0 &&
        routingData?.find(res => {
          if (res.code === psaconsultantData.hrConsultant) {
            return res;
          }
        }),
      executive:
        routingData?.length > 0 &&
        routingData?.find(res => {
          if (res.code === psaconsultantData.executive) {
            return res;
          }
        }),
      hrexecutive:
        routingData?.length > 0 &&
        routingData?.find(res => {
          if (res.code === psaconsultantData.hrexecutive) {
            return res;
          }
        }),
      // submittedCompletedFormTo:
      //   routingData?.length > 0 &&
      //   routingData?.find(res => {
      //     if (res.code === psaconsultantData.submittedCompletedFormTo){
      //       return res;
      //     }
      //   })
      //   ,

      pSAPartyFilePath: pSAPartyData?.filePath,
      pSAPartyFileName: pSAPartyData?.filename,
      pSAPartyFileName2: pSAPartyData?.filename2,
      expireDate: psaconsultantData.expireDate && new Date(psaconsultantData.expireDate),
      notifyDays: psaconsultantData.notifyDays,
      agreementDate: psaconsultantData.agreementDate && new Date(psaconsultantData.agreementDate),
      effectiveDate: psaconsultantData.effectiveDate && new Date(psaconsultantData.effectiveDate),
      reviewDate: psaconsultantData.reviewDate && new Date(psaconsultantData.reviewDate),
      dateofboard: psaconsultantData.dateofboard && new Date(psaconsultantData.dateofboard),
      businessEntity: psaconsultantData?.businessEntity && psaconsultantData?.businessEntity?.split(","),
      submittedTo: pSAPartyData && pSAPartyData.party ? pSAPartyData.party : psaconsultantData?.submittedTo
    },
    // initialValues:{
    //   typeBE : []
    // },
    validate: data => {
      let errors = {};
      return errors;
    },
    onSubmit: data => {
      const dummFormData = { ...formData, ...data };
      // setFormData({dummFormData})
      setFormData(dummFormData);
      saveBasicInfo("save", dummFormData);
      formik.resetForm();
    }
  });

  async function saveData(formData) {
    const otp = Math.floor(Math.random() * 10000000);
    const businessEntityStr = formData?.businessEntity && formData?.businessEntity.toString();

    // const savedData = await DataStore.save(
    // new PSAConsultant({
    // assignmentTitle: formData?.assignmentTitle,
    // department: formData?.department?.code,
    // amount: formData?.amount,
    // expireDate: formData?.expireDate && moment(formData?.expireDate).format("YYYY-MM-DD"),
    // notifyDays: formData?.notifyDays,
    // accountNo: formData?.accountNo,
    // boardItem: formData?.boardItem,
    // services: formData?.services,
    // agreementDate: formData?.agreementDate && moment(formData?.agreementDate).format("YYYY-MM-DD"),
    // effectiveDate: formData?.effectiveDate && moment(formData?.effectiveDate).format("YYYY-MM-DD"),
    // reviewDate: formData?.reviewDate && moment(formData?.reviewDate).format("YYYY-MM-DD"),
    //// submittedTo: formData?.submittedTo?.code,
    // dateofboard: formData?.dateofboard && moment(formData?.dateofboard).format("YYYY-MM-DD"),
    // pageItem: formData?.pageItem,
    // psaEmail: formData?.psaEmail,
    // businessEntity: businessEntityStr,
    //// typeBE: ["1","0","2"],
    // referenceNo: formData?.referenceNo,
    // purchaseOrderNo: formData?.purchaseOrderNo,
    // addendumNo: formData?.addendumNo,
    // notes: formData?.notes,
    // otherRemark: formData?.otherRemark,
    // filename: formData?.filename,
    // otp,
    // budgetClerk: formData?.budgetClerk?.code ? formData?.budgetClerk?.code : selectedFirstApprover?.code,
    // budgetManager: formData?.budgetManager?.code ? formData?.budgetManager?.code : (selectedBudgetManagerApprover) ? selectedBudgetManagerApprover.code : null,
    // hrConsultant: formData?.hrexecutive?.code ? formData?.hrexecutive?.code : selectedPayroll?.code,             //formData?.hrConsultant?.code ? formData?.hrConsultant?.code : selectedSecondApprover?.code,
    // hrexecutive: formData?.hrexecutive?.code ? formData?.hrexecutive?.code : selectedPayroll?.code,
    // executive: formData?.executive?.code ? formData?.executive?.code : selectedThirdApprover?.code,
    // submittedCompletedFormTo: formData?.submittedCompletedFormTo,
    //// businessEntity: "",
    // createdBy: loggedUserId,
    // submittedTo: formData?.submittedTo
    // })
    // );

    const savedDataNew = await API.graphql(
      graphqlOperation(mutations.createPSAConsultant, {
        input: {
          assignmentTitle: formData?.assignmentTitle,
          department: formData?.department?.code,
          amount: formData?.amount,
          expireDate: formData?.expireDate && moment(formData?.expireDate).format("YYYY-MM-DD"),
          notifyDays: formData?.notifyDays,
          accountNo: formData?.accountNo,
          boardItem: formData?.boardItem,
          services: formData?.services,
          agreementDate: formData?.agreementDate && moment(formData?.agreementDate).format("YYYY-MM-DD"),
          effectiveDate: formData?.effectiveDate && moment(formData?.effectiveDate).format("YYYY-MM-DD"),
          reviewDate: formData?.reviewDate && moment(formData?.reviewDate).format("YYYY-MM-DD"),
          // submittedTo: formData?.submittedTo?.code,
          dateofboard: formData?.dateofboard && moment(formData?.dateofboard).format("YYYY-MM-DD"),
          pageItem: formData?.pageItem,
          psaEmail: formData?.psaEmail,
          businessEntity: businessEntityStr,
          // typeBE: ["1","0","2"],
          referenceNo: formData?.referenceNo,
          purchaseOrderNo: formData?.purchaseOrderNo,
          addendumNo: formData?.addendumNo,
          notes: formData?.notes,
          otherRemark: formData?.otherRemark,
          filename: formData?.filename,
          otp,
          budgetClerk: formData?.budgetClerk?.code ? formData?.budgetClerk?.code : selectedFirstApprover?.code,
          budgetManager: formData?.budgetManager?.code ? formData?.budgetManager?.code : (selectedBudgetManagerApprover) ? selectedBudgetManagerApprover.code : null,
          hrConsultant: formData?.hrexecutive?.code ? formData?.hrexecutive?.code : selectedPayroll?.code,             //formData?.hrConsultant?.code ? formData?.hrConsultant?.code : selectedSecondApprover?.code,
          hrexecutive: formData?.hrexecutive?.code ? formData?.hrexecutive?.code : selectedPayroll?.code,
          executive: formData?.executive?.code ? formData?.executive?.code : selectedThirdApprover?.code,
          submittedCompletedFormTo: formData?.submittedCompletedFormTo,
          // businessEntity: "",
          createdBy: loggedUserId,
          submittedTo: formData?.submittedTo
        }
      })
    );

    const savedData = savedDataNew.data.createPSAConsultant;
    // let message = `<p>Please find your PSA Consultant form</p><br/><p>Your Otp is ${otp}. </p>`;
    // message += "<a href='http://localhost:3000/psaconsultant/" + savedData.id + "' >PSA Consultant</a>";
    // SendNotificationEmail("snarola@hexalytics.com", "PSA consultant form detail", message);
    if (savedData) {
      if (docList.length > 0) {
        //file upload

        for (let i = 0; i < docList.length; i++) {

          let transNameFile = docList?.[i].filename.replace(/\s+/g, '_');
          let id = savedData?.id;
          // const filePath = "public/psaconsultant/" + id + "/document/" + transNameFile;
          const filePath = "psaconsultant/" + id + "/document/" + transNameFile;

          //const res = await UploadFileOnS3(file[0], filePath).catch(error => toast.error(error));

          const res = await Storage.put(filePath, docList?.[i].file, {
            progressCallback(progress) { }
          });

          // const docSavedData = await DataStore.save(
          // new PSADocuments({
          // reportId: id,
          // filename: transNameFile,
          // filepath: filePath
          // })
          // );

          const docSavedData = await API.graphql(
            graphqlOperation(mutations.createPSADocuments, {
              input: {
                reportId: id,
                filename: transNameFile,
                filepath: filePath
              }
            })
          );
        }
      }
      //empty doclist after save
      setDocList([])

      if (iSCopyForm) {
        toast.success("The form has been cloned.");
        setISCopyForm(false);
      } else {
        toast.success("Data Added Successfully.");
      }
      setPsaconsultantData(savedData);
      // getRoutingData(savedData)
      // getMasterData();
      BindList();
      setBtnDisabled(false);
      return savedData;
    }
  }
  async function updateData(formData) {
    const otp = Math.floor(Math.random() * 10000000);
    //const original = await DataStore.query(PSAConsultant, psaconsultantData?.id);
    const original = await graphQLFindRecordById("getPSAConsultant", psaconsultantData?.id);
    const businessEntityStr = formData?.businessEntity && formData?.businessEntity.toString();

    let PSATransactionCycleData = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: psaconsultantData?.id } }])
    PSATransactionCycleData = PSATransactionCycleData.sort((b, a) => (a.createdAt).localeCompare(b.createdAt));

    // let transactionCycleResponse = substituteCertificateRequestTransactionCycles.sort((b, a) => (a.createdAt).localeCompare(b.createdAt));

    // const updatedData = await DataStore.save(
    // PSAConsultant.copyOf(original, updated => {
    // updated.assignmentTitle = formData?.assignmentTitle;
    // updated.department = formData?.department?.code;
    // updated.amount = formData?.amount;
    // updated.expireDate = formData?.expireDate && moment(formData?.expireDate).format("YYYY-MM-DD");
    // updated.notifyDays = formData?.notifyDays;
    // updated.accountNo = formData?.accountNo;
    // updated.boardItem = formData?.boardItem;
    // updated.services = formData?.services;
    // updated.agreementDate = formData?.agreementDate && moment(formData?.agreementDate).format("YYYY-MM-DD");
    // updated.effectiveDate = formData?.effectiveDate && moment(formData?.effectiveDate).format("YYYY-MM-DD");
    // updated.reviewDate = formData?.reviewDate && moment(formData?.reviewDate).format("YYYY-MM-DD");
    ////////updated.submittedTo = formData?.submittedTo?.code;
    // updated.dateofboard = formData?.dateofboard && moment(formData?.dateofboard).format("YYYY-MM-DD");
    // updated.pageItem = formData?.pageItem;
    // updated.psaEmail = formData?.psaEmail;
    // updated.typeBE = formData?.typeBE;
    // updated.notes = formData?.notes;
    // updated.otherRemark = formData?.otherRemark;
    // updated.filename = formData?.filename;
    // updated.otp = otp;
    // updated.budgetClerk = formData?.budgetClerk?.code ? formData?.budgetClerk?.code : selectedFirstApprover?.code;
    // updated.budgetManager = formData?.budgetManager?.code ? formData?.budgetManager?.code : (selectedFirstApprover) ? selectedFirstApprover?.code : '';

    // updated.hrConsultant = formData?.hrexecutive?.code ? formData?.hrexecutive?.code : selectedPayroll?.code;      //formData?.hrConsultant?.code ? formData?.hrConsultant?.code : selectedSecondApprover?.code;
    // updated.hrexecutive = formData?.hrexecutive?.code ? formData?.hrexecutive?.code : selectedPayroll?.code;
    // updated.executive = formData?.executive?.code ? formData?.executive?.code : selectedThirdApprover?.code;
    // updated.submittedCompletedFormTo = formData?.submittedCompletedFormTo;
    // updated.referenceNo = formData?.referenceNo;
    // updated.purchaseOrderNo = formData?.purchaseOrderNo;
    // updated.addendumNo = formData?.addendumNo;
    // updated.businessEntity = formData?.businessEntity && formData?.businessEntity.toString();
    // updated.submittedTo = formData?.submittedTo;
    // })
    // );

    let updatedData;

if(superAdminEditor){

  const updatedDataNew = await API.graphql({
    query: mutations.updatePSAConsultant,
    variables: {
      input: {
        id: original.id,
        _version: original._version,
        assignmentTitle: formData?.assignmentTitle,
        department: formData?.department?.code,
        amount: formData?.amount,
        expireDate: formData?.expireDate && moment(formData?.expireDate).format("YYYY-MM-DD"),
        notifyDays: formData?.notifyDays,
        accountNo: formData?.accountNo,
        boardItem: formData?.boardItem,
        services: formData?.services,
        agreementDate: formData?.agreementDate && moment(formData?.agreementDate).format("YYYY-MM-DD"),
        effectiveDate: formData?.effectiveDate && moment(formData?.effectiveDate).format("YYYY-MM-DD"),
        reviewDate: formData?.reviewDate && moment(formData?.reviewDate).format("YYYY-MM-DD"),
        //// submittedTo : formData?.submittedTo?.code,
        dateofboard: formData?.dateofboard && moment(formData?.dateofboard).format("YYYY-MM-DD"),
        pageItem: formData?.pageItem,
        psaEmail: formData?.psaEmail,
        //typeBE : formData?.typeBE,
        notes: formData?.notes,
        otherRemark: formData?.otherRemark,
        filename: formData?.filename,
        otp: otp,
        budgetClerk: formData?.budgetClerk?.code ? formData?.budgetClerk?.code : selectedFirstApprover?.code,
        budgetManager: formData?.budgetManager?.code ? formData?.budgetManager?.code : (selectedFirstApprover) ? selectedFirstApprover?.code : '',

        hrConsultant: formData?.hrexecutive?.code ? formData?.hrexecutive?.code : selectedPayroll?.code,      //formData?.hrConsultant?.code ? formData?.hrConsultant?.code : selectedSecondApprover?.code,
        hrexecutive: formData?.hrexecutive?.code ? formData?.hrexecutive?.code : selectedPayroll?.code,
        executive: formData?.executive?.code ? formData?.executive?.code : selectedThirdApprover?.code,
        submittedCompletedFormTo: formData?.submittedCompletedFormTo,
        referenceNo: formData?.referenceNo,
        purchaseOrderNo: formData?.purchaseOrderNo,
        addendumNo: formData?.addendumNo,
        businessEntity: formData?.businessEntity && formData?.businessEntity.toString(),
        submittedTo: formData?.submittedTo,
      }
    }
  });


   updatedData = updatedDataNew.data.updatePSAConsultant

  //  let updatedMetaData=updateMetaData?.data?.updateSubstituteCertificateRequest;
    //get who is to employee for old data
    let initiatorId=original.createdBy;
    let hrConsultant=original.hrConsultant;
    let hrexecutive=original?.hrexecutive;
    let budgetManager=original?.budgetManager
    let budgetClerk=original?.budgetClerk;

    if (PSATransactionCycleData.length > 0) {
      let toEmployeeId="";
      let toEmpId=PSATransactionCycleData[0].to_Employee_Id;
      switch(toEmpId){
          case hrConsultant:
          toEmployeeId=updatedData?.hrConsultant;
          break;

          case budgetClerk:
          toEmployeeId=updatedData?.budgetClerk;
          break;

          case budgetManager:
          toEmployeeId=updatedData?.budgetManager;
          break;

          case hrexecutive:
          toEmployeeId=updatedData?.hrexecutive;
          break;

          default:
          toEmployeeId=""
      }

      // Create record
      if(toEmployeeId !=""){

      var substituteCertificateRequestTransactionCycle = await API.graphql(
          graphqlOperation(mutations.updatePSATransactionCycle, {
              input: {
                  id: PSATransactionCycleData[0].id,
                  _version: PSATransactionCycleData[0]._version,
                  to_Employee_Id: toEmployeeId,
                  isApproved: false,
                  remark: "",
                  dateTime: moment().toISOString(),
              }
          })
      );

      handleNotificationsOnStatusChangeforPSA(PSATransactionCycleData[0].status, original.id, "PERSONAL_SERVICE_AGREEMENT", toEmployeeId, original.createdBy,"");

      }
  }


}else{
  const updatedDataNew = await API.graphql({
    query: mutations.updatePSAConsultant,
    variables: {
      input: {
        id: original.id,
        _version: original._version,
        assignmentTitle: formData?.assignmentTitle,
        department: formData?.department?.code,
        amount: formData?.amount,
        expireDate: formData?.expireDate && moment(formData?.expireDate).format("YYYY-MM-DD"),
        notifyDays: formData?.notifyDays,
        accountNo: formData?.accountNo,
        boardItem: formData?.boardItem,
        services: formData?.services,
        agreementDate: formData?.agreementDate && moment(formData?.agreementDate).format("YYYY-MM-DD"),
        effectiveDate: formData?.effectiveDate && moment(formData?.effectiveDate).format("YYYY-MM-DD"),
        reviewDate: formData?.reviewDate && moment(formData?.reviewDate).format("YYYY-MM-DD"),
        //// submittedTo : formData?.submittedTo?.code,
        dateofboard: formData?.dateofboard && moment(formData?.dateofboard).format("YYYY-MM-DD"),
        pageItem: formData?.pageItem,
        psaEmail: formData?.psaEmail,
        //typeBE : formData?.typeBE,
        notes: formData?.notes,
        otherRemark: formData?.otherRemark,
        filename: formData?.filename,
        otp: otp,
        budgetClerk: formData?.budgetClerk?.code ? formData?.budgetClerk?.code : selectedFirstApprover?.code,
        budgetManager: formData?.budgetManager?.code ? formData?.budgetManager?.code : (selectedFirstApprover) ? selectedFirstApprover?.code : '',

        hrConsultant: formData?.hrexecutive?.code ? formData?.hrexecutive?.code : selectedPayroll?.code,      //formData?.hrConsultant?.code ? formData?.hrConsultant?.code : selectedSecondApprover?.code,
        hrexecutive: formData?.hrexecutive?.code ? formData?.hrexecutive?.code : selectedPayroll?.code,
        executive: formData?.executive?.code ? formData?.executive?.code : selectedThirdApprover?.code,
        submittedCompletedFormTo: formData?.submittedCompletedFormTo,
        referenceNo: formData?.referenceNo,
        purchaseOrderNo: formData?.purchaseOrderNo,
        addendumNo: formData?.addendumNo,
        businessEntity: formData?.businessEntity && formData?.businessEntity.toString(),
        submittedTo: formData?.submittedTo,
      }
    }
  });
  updatedData = updatedDataNew.data.updatePSAConsultant

}
    


    //update  part Name
    //const originalPartyPSA1 = await DataStore.query(PSAParty, c => c.psaConsultantId.eq(psaconsultantData?.id));
    const originalPartyPSA1 = await graphQLGetAllData("listPSAParties", [{ psaConsultantId: { eq: psaconsultantData?.id } }]);
    if (originalPartyPSA1.length > 0) {

      // const updatedPSAConsultParty2 = await DataStore.save(
      // PSAParty.copyOf(originalPartyPSA1[0], updated => {
      // updated.party = formData?.submittedTo;

      //update Party details
      // updated.party = formData?.party;
      // updated.clientId = formData?.clientId;
      // updated.pocName = formData?.pocName;
      // updated.pocNumber = formData?.pocNumber;
      // updated.email = formData?.psaEmail;
      // updated.ssn = formData?.ssn;
      // updated.employerID = formData?.employerID;
      // updated.typeBE = formData?.typeBE;
      // updated.title = formData?.title;
      // updated.license = formData?.license;
      // updated.state = formData?.state;
      // updated.city = formData?.city;
      // updated.address = formData?.address;
      // updated.zip = formData?.zip;
      // })
      // );


      const updatedPSAConsultParty2 = await API.graphql({
        query: mutations.updatePSAParty,
        variables: {
          input: {
            id: originalPartyPSA1[0].id,
            _version: originalPartyPSA1[0]._version,
            party: formData?.party,
            // clientId : formData?.clientId,
            pocName: formData?.pocName,
            pocNumber: formData?.pocNumber,
            email: formData?.psaEmail,
            ssn: formData?.ssn,
            employerID: formData?.employerID,
            typeBE: formData?.typeBE,
            title: formData?.title,
            license: formData?.license,
            state: formData?.state,
            city: formData?.city,
            address: formData?.address,
            zip: formData?.zip,

          }
        }
      });

      setPSAPartyData(updatedPSAConsultParty2)
    } else {

      // var PSAParty1 = await DataStore.save(
      // new PSAParty({
      // party: formData?.party,
      // clientId: formData?.clientId,
      // pocName: formData?.pocName,
      // pocNumber: formData?.pocNumber,
      // email: formData?.psaEmail,
      // ssn: formData?.ssn,
      // employerID: formData?.employerID,
      // typeBE: formData?.typeBE,
      // title: formData?.title,
      // license: formData?.license,
      // state: formData?.state,
      // city: formData?.city,
      // address: formData?.address,
      // zip: formData?.zip,
      // psaConsultantId: psaconsultantData?.id,
      // })
      // );


      var PSAParty1 = await API.graphql(
        graphqlOperation(mutations.createPSAParty, {
          input: {
            party: formData?.party,
            // clientId: formData?.clientId,
            pocName: formData?.pocName,
            pocNumber: formData?.pocNumber,
            email: formData?.psaEmail,
            ssn: formData?.ssn,
            employerID: formData?.employerID,
            typeBE: formData?.typeBE,
            title: formData?.title,
            license: formData?.license,
            state: formData?.state,
            city: formData?.city,
            address: formData?.address,
            zip: formData?.zip,
            psaConsultantId: psaconsultantData?.id,
          }
        })
      );


      setPSAPartyData(PSAParty1)
    }


    if (updatedData) {
      if (docList.length > 0) {
        //file upload


        // const deleteFiles = await DataStore.delete(PSADocuments, (c) => c.reportId.eq(psaconsultantData?.id).filename.contains());


        for (let i = 0; i < docList.length; i++) {

          let transNameFile = docList?.[i].filename.replace(/\s+/g, '_');
          let id = psaconsultantData?.id;
          // const filePath = "public/psaconsultant/" + id + "/document/" + transNameFile;
          const filePath = "psaconsultant/" + id + "/document/" + transNameFile;

          //const res = await UploadFileOnS3(file[0], filePath).catch(error => toast.error(error));

          const res = await Storage.put(filePath, docList?.[i].file, {
            progressCallback(progress) { }
          });

          // const savedData = await DataStore.save(
          // new PSADocuments({
          // reportId: id,
          // filename: transNameFile,
          // filepath: filePath
          // })
          // );



          const savedData = await API.graphql(
            graphqlOperation(mutations.createPSADocuments, {
              input: {
                reportId: id,
                filename: transNameFile,
                filepath: filePath
              }
            })
          );


          // if (res) {
          //   // formik.setFieldValue("filename", filePath);
          //   toast.success("File uploaded Successfully");
          // } else {
          //   toast.error("File is not Uploaded Successfully");
          // }
        }

        // if (res) {
        //   // formik.setFieldValue("filename", filePath);
        //   toast.success("File uploaded Successfully");
        // } else {
        //   toast.error("File is not Uploaded Successfully");
        // }
      }
      // empty doclist after save
      setDocList([])
      // if (docList.length && docList[0].filename) {
      //   //file upload
      //   let transNameFile = docList[0].filename;
      //   let id = psaconsultantData?.id;
      //   // const filePath = "public/psaconsultant/" + id + "/document/" + transNameFile;
      //   const filePath = "psaconsultant/" + id + "/document/" + transNameFile;

      //   //const res = await UploadFileOnS3(file[0], filePath).catch(error => toast.error(error));

      //   const res = await Storage.put(filePath, docList[0].file, {
      //     progressCallback(progress) { }
      //   });
      //   if (res) {
      //     formik.setFieldValue("filename", filePath);
      //     toast.success("File uploaded Successfully");
      //   } else {
      //     toast.error("File is not Uploaded Successfully");
      //   }
      // }
      toast.success("Data Updated Successfully.");
      setPsaconsultantData(updatedData);
      setBtnDisabled(false);
      // getRoutingData(updatedData);
      return updatedData;
    }
  }
  const inputFile = useRef(null);
  function validateFileExtension(file_field, allowedExtensions, e) {
    let flag = false;
    let extension = file_field.substr(file_field.lastIndexOf(".") + 1).toLowerCase();
    if (allowedExtensions.indexOf(extension) === -1) {
      if (inputFile.current) {
        inputFile.current.value = "";
        inputFile.current.type = "text";
        inputFile.current.type = "file";
      }
      flag = true;
    }
    return flag;
  }

  const [docList, setDocList] = useState([]);

  const [documentList, setDocumentList] = useState([
    {
      itemId: 0,
      filename: "",
      file: ""
    }
  ]);

  async function uploadDocuments(e) {


    let file = e.target.files;

    let file_field = file[0].name;
    let allowedExtensions = ["pdf"];
    let flag = false;

    if (file?.length > 0) {
      // file.map(res =>{

      // })

      for (let i = 0; i < file?.length; i++) {
        const res = file[i];
        flag = validateFileExtension(res.name, allowedExtensions, e);

        // let extension = file_field.substr(file_field.lastIndexOf('.') + 1).toLowerCase();
        if (flag) {
          e.target.value = null;
          //setFileName([]);

          toast.error("Please Select Valid file Format. Only " + allowedExtensions.join(", ") + " are allowed.");
          return;
        } else {
          // let transNameFile = "filename.pdf"

          let data = [{ filename: "", file: "" }];
          // data[index]["file"] = e.target.value;
          setFileName(prev => [...prev, e.target.files[i].name]);
          data[0]["filename"] = file[i].name;
          data[0]["file"] = file[i];

          if (file.length > 0) {
            setDocList(prev => [...prev, ...data]);
          }
        }
      }
    }
  }

  const handleKeyUp = event => {
    const query = event.query;


    let filteredData = empCodeList.filter(item => item.name.toLowerCase().includes(query.toLowerCase()));

    filteredData = filteredData.map(item => item.name);

    setItems(filteredData);
    //setFilteredItems(filteredData);
  };

  const footerContent1 = (
    <div className="text-center">
      <button
        className="border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded"
        onClick={() => {
          setConfirmVisible2(false);
          setShowNextPopUp(false);
          setVisibleCreteReportPopup(false);
          setShowPreviewPopUp(false);
          SetBasicInfoPopUp(true);
          SetPreviewAndEdit(false);
        }}
      >
        Close
      </button>
    </div>
  );


  async function removeFromS3(filePath) {
    filePath = filePath.replace("public/", "");
    filePath = "public/" + filePath
    await GetAWSObjectDelete(fileName);

  }
  //onclick remove inquiry document
  const onClickRemoveDoc = async (index) => {
    let data = [...initiatorDocuments];
    const record = data[index]

    if (data.length > 0) {
      data.splice(index, 1)
      setInitiatorDocuments(data)
      await removeFromS3(record?.filepath)
      //const deleteFiles = await DataStore.delete(PSADocuments, record?.id);
      const deleteFiles = await API.graphql({
        query: mutations.deletePSADocuments,
        variables: {
          input: {
            id: record?.id,
            _version: record?._version
          }
        }
      });

      toast.success("File Removed successfully");
    }
  }

  async function OpenDocument(filePath) {
    filePath = filePath.replace("public/", "");
    filePath = "public/" + filePath;
    let filePathURL = await GetAWSObjectURL(filePath);

    const iframe = document.createElement("iframe");
    iframe.src = filePathURL;
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000); // Adjust the delay as needed
  }

  const clearBudgetClerkField = (e) => {
    e.preventDefault();
    formik.setFieldValue("budgetClerk", '');
    setSelectedFirstApprover('')
    formik.setFieldValue("budgetManager", '');
    setSelectedBudgetManagerApprover(null);
  };


  var selectedCountryTemplate = (option, props) => {
    if (option) {
      return <div className="flex w-full justify-between"><p>{option.name ? option.name : null}</p><p onClick={clearBudgetClerkField}><i className="pi pi-times" style={{ fontSize: '1vw' }}></i></p></div>
    }
    return <span>{props.placeholder}</span>

  }

  return (
    <>
      <Dialog
        className="relative reports-popup"
        visible={showNextPopUp}
        position="right"
        style={{ width: "100vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        onHide={() => setShowNextPopUp(false)}
        draggable={false}
        resizable={false}
      >
        {/* <div class="p-10"><a href="#" id="add-family-open-btn"><i class="gusd-edit text-2xl"></i></a></div> */}
        <div className="fixed z-10 inset-0 overflow-y-auto styled-select">
          <div className="flex items-start justify-center min-h-full h-full bg-[#FBFDFF]">
            <div className="relative overflow-hidden transform transition-all w-full h-full">
              <div className="grid grid-cols-12 custmCols">
                <div className="col-span-3 h-full sideBarLeft openSideDiv">
                  <button
                    onClick={() => {
                      setISCopyForm(false);
                      setShowNextPopUp(false);
                      SetBasicInfoPopUp(true);
                      SetAttchmentAndDetailes(false);
                      setPartyDetailesPopUp(false);
                      SetTermsAndConditions(false);
                      SetEddDetailes(false);
                      SetPreviewAndEdit(false);
                      setShowPreviewPopUp(false);
                      setIsEdit(false);
                      setFileName([]);
                      setDocList([]);
                      setSelectedFirstApprover("")
                      setSelectedSecondApprover("")
                      setSelectedBudgetManagerApprover(null)
                      setSelectedThirdApprover("")
                      setFormData([])
                      setSelectedPayroll("")
                      if (srcReportIdPsa) {
                        setIsMasterDataLoaded()
                      }
                      else {
                        getMasterData();
                      }
                      formik.resetForm()
                      if (isApproverEdit) {
                        // setAddSignature(false)
                        if(superAdminEditor){
                        setActiveIndex(0);
                        }else{
                          setActiveIndex(1);
                        }
                      } else {
                        setPsaconsultantData([])
                      }
                    }}
                    type="button"
                    className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
                    id="add-family-cancel-btn"
                  >
                    <i className="gusd-arrow-line-right mr-[14px] xl:mr-[0.729vw]"></i> Back Home
                  </button>




                  <div className="mt-[16px] xl:mt-[0.833vw] text-[#101828] text-[14px] xl:text-[0.633vw] font-normal">
                    GUSD Personal Service Agreement
                  </div>
                  {/*  <div className="mt-[10px] xl:mt-[0.533vw] text-[#101828] text-[20px] xl:text-[0.833vw] font-medium">
                    Assignment 10102
                  </div> */}
                  <div className="mt-[32px] xl:[1.667vw]">
                    <ul className="sideTabs">
                      <li>
                        <a
                          href="#"
                          onClick={() => {
                            if (isEdit) {
                              const dummFormData = { ...formData, ...formik.values };
                              setFormData(dummFormData);
                              setShowPreviewPopUp(false);
                              SetBasicInfoPopUp(true);
                              setPartyDetailesPopUp(false);
                              SetAttchmentAndDetailes(false);
                              SetTermsAndConditions(false);
                              SetW9Detailes(false);
                              SetEddDetailes(false);
                              SetPreviewAndEdit(false);
                            }
                          }}
                          className={`${basicInfoPopUp === true ? "tab-b active activeCheck" : ""}`}
                          data-id="tab1"
                        >
                          <i className="gusd-guardian-info text-[10px] xl:text-[1.042vw]"></i>
                          Basic Info
                        </a>
                      </li>

                      <li>
                        <a
                          href="javascript:void(0);"
                          onClick={() => {
                            if (isEdit) {
                              const dummFormData = { ...formData, ...formik.values };
                              setFormData(dummFormData);
                              setPartyDetailesPopUp(false);
                              SetBasicInfoPopUp(false);
                              SetAttchmentAndDetailes(true);
                              SetTermsAndConditions(false);
                              SetW9Detailes(false);
                              SetEddDetailes(false);
                              SetPreviewAndEdit(false);
                              setShowPreviewPopUp(false);
                            }
                          }}
                          className={`${attchmentAndDetailes === true ? "tab-b active activeCheck" : null}`}
                          class="tab-b"
                          data-id="tab3"
                        >
                          <i class="gusd-guardian-info text-[16px] xl:text-[1.042vw]"></i>Attachments & Notes
                        </a>
                      </li>

                      {isEdit && (
                        <li>
                          <a
                            href="#"
                            onClick={() => {
                              if (isEdit) {
                                const dummFormData = { ...formData, ...formik.values };
                                setFormData(dummFormData);
                                setPartyDetailesPopUp(true);
                                SetBasicInfoPopUp(false);
                                SetAttchmentAndDetailes(false);
                                SetTermsAndConditions(false);
                                SetW9Detailes(false);
                                SetEddDetailes(false);
                                SetPreviewAndEdit(false);
                                setShowPreviewPopUp(false);
                              }
                            }}
                            className={`${partyDetailesPopup === true ? "tab-b active activeCheck" : null}`}
                            class="tab-b"
                            data-id="tab3"
                          >
                            <i class="gusd-guardian-info text-[16px] xl:text-[1.042vw]"></i>PSA Consultant Details
                          </a>
                        </li>
                      )}

                      <li>
                        <a
                          href="javascript:void(0);"
                          onClick={() => {
                            if (isEdit) {
                              const dummFormData = { ...formData, ...formik.values };
                              setFormData(dummFormData);
                              setPartyDetailesPopUp(false);
                              SetBasicInfoPopUp(false);
                              SetAttchmentAndDetailes(false);
                              SetTermsAndConditions(true);
                              SetW9Detailes(false);
                              SetEddDetailes(false);
                              SetPreviewAndEdit(false);
                              setShowPreviewPopUp(false);
                            }
                          }}
                          className={`${termsAndConditions === true ? "tab-b active activeCheck" : null}`}
                          class="tab-b"
                          data-id="tab3"
                        >
                          <i class="gusd-guardian-info text-[16px] xl:text-[1.042vw]"></i>Terms & Conditions
                        </a>
                      </li>

                      <li>
                        <a
                          href="javascript:void(0);"
                          onClick={() => {
                            if (isEdit) {
                              const dummFormData = { ...formData, ...formik.values };
                              setFormData(dummFormData);
                              setPartyDetailesPopUp(false);
                              SetBasicInfoPopUp(false);
                              SetAttchmentAndDetailes(false);
                              SetTermsAndConditions(false);
                              SetW9Detailes(false);
                              SetEddDetailes(true);
                              SetPreviewAndEdit(false);
                              setShowPreviewPopUp(false);
                            }
                          }}
                          className={`${eddDetailes === true ? "tab-b active activeCheck" : null}`}
                          class="tab-b"
                          data-id="tab3"
                        >
                          <i class="gusd-guardian-info text-[16px] xl:text-[1.042vw]"></i>Routing
                        </a>
                      </li>

                      {/* <li><a href="javascript:void(0);" onClick={() => { setPartyDetailesPopUp(false); SetBasicInfoPopUp(false); SetAttchmentAndDetailes(false); SetTermsAndConditions(false); SetW9Detailes(true); SetEddDetailes(false); SetPreviewAndEdit(false) }} class="tab-b"
                          className={`${w9Detailes === true ? "tab-b active activeCheck" : null}`} data-id="tab3"><i class="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i>W9 Details</a></li> */}

                      <li>
                        <a
                          href="#"
                          onClick={() => {
                            if (isEdit) {
                              const dummFormData = { ...formData, ...formik.values };
                              setFormData(dummFormData);
                              setPartyDetailesPopUp(false);
                              SetBasicInfoPopUp(false);
                              SetAttchmentAndDetailes(false);
                              SetTermsAndConditions(false);
                              SetW9Detailes(false);
                              SetEddDetailes(false);
                              SetPreviewAndEdit(true);
                              setShowPreviewPopUp(true);
                            }
                          }}
                          className={`${previewAndEdit === true ? "tab-b active activeCheck" : null}`}
                          data-id="tab3"
                        >
                          <i className="gusd-guardian-info text-[16px] xl:text-[1.042vw]"></i> Preview & Edit
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/* <div className="fixed top-0 left-0 openBtn xl:hidden">
                    <button
                      type="button"
                      className="sideDivBtn inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-white text-[14px] xl:text-[0.729vw] font-medium bg-[#3366FF] border border-[#EFF8FF] rounded-r-md"
                    >
                      <i className="gusd-arrow-line-right"></i>
                    </button>
                  </div> */}
                </div>

                <div
                  className={`col-span-9 xl:col-span-6 2xl:col-span-6 md:col-span-7 
                  mScrollCstm  
                  ${termsAndConditions === true ? "relative" : "overflow-auto"}
                  
                  `}
                >
                  <div
                    className={`tab-c tab-active p-lr-110 pt-[0px]    ${termsAndConditions === true ? "overflow-auto" : null
                      }`}
                    data-id="tab1"
                  >
                    {basicInfoPopUp === true ? (
                      <div>
                        <div className="text-[#000000] font-medium xl:text-[1.406vw] text-[24px]">Basic Info</div>
                        <div className="mCustomScrollbar scroll-w-10 max-h-100">
                          <div className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] ">
                            <form>
                              <div className=" grid grid-cols-2 gap-x-8 xl:gap-y-[1.250vw] gap-y-[20px]">
                                <div className="col-span-2">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    Assignment Title<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <input
                                    onChange={e => {
                                      formik.setFieldValue("assignmentTitle", e.target.value);
                                    }}
                                    defaultValue={formData?.assignmentTitle}
                                    type="text"
                                    name=""
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Type here"
                                  />
                                </div>

                                <div className="">
                                  <div className="col ">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Site/Department<span className="text-[red] pl-0.2">*</span>
                                    </label>
                                    <Dropdown
                                      value={formik.values?.department}
                                      defaultValue={formData?.department}
                                      showClear
                                      onChange={e => {
                                        formik.setFieldValue("department", e.value);
                                      }}
                                      options={schoolList}
                                      optionLabel="name"
                                      placeholder="Select a department"
                                      filter
                                      // valueTemplate={selectedCountryTemplate}
                                      className="w-full md:w-14rem"
                                    />
                                  </div>

                                  <div className="col ">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Amount<span className="text-[red] pl-0.2">*</span>
                                    </label>
                                    <input
                                      value={formik.values?.amount}
                                      defaultValue={formData?.amount}
                                      onChange={(e) => {
                                        let numericValue = e.target.value.replace(/[^0-9]/g, "");
                                        numericValue = numericValue.replace(/^0+/, ""); // Remove leading zeros
                                        formik.setFieldValue("amount", numericValue);
                                      }}
                                      type="text"
                                      name=""
                                      class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                      placeholder="Type here"
                                    />
                                  </div>

                                  <div className="col mt-1.5">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Expiration Date<span className="text-[red] pl-0.2">*</span>
                                    </label>
                                    <div className="relative custp-calender">
                                      <i
                                        className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"
                                        onClick={() => openCalendar("expireDate")}
                                      ></i>
                                      <i
                                        className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"
                                        onClick={() => openCalendar("expireDate")}
                                      ></i>
                                      <div className="card flex justify-content-center">
                                        <Calendar
                                          ref={inputRef1}
                                          value={formik.values.expireDate}
                                          onChange={e => {
                                            formik.setFieldValue("expireDate", e.target.value);
                                            setExpirationDate(e.target.value)
                                          }}
                                          onInput={(e) => validateDate(e)}
                                          // disabled={expirationDisabled}
                                          disabled={formik.values.effectiveDate ? false : true}
                                          placeholder="Start Date"
                                          className="w-full h-11"
                                          minDate={formik.values.effectiveDate}
                                          maxDate={""}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Notify Days
                                  
                                    </label>
                                    <div className="">
                                      <div className="relative custp-calender">
                                  
                                        <div className="card flex justify-content-center">
                                        
                                          <input
                                            value={formik.values.notifyDays}
                                            onChange={e => {
                                              const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                              formik.setFieldValue("notifyDays", numericValue);
                                            }}
                                            type="text"
                                            name=""
                                            class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                            placeholder="Type here"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div> */}

                                  <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Account No.<span className="text-[red] pl-0.2">*</span>
                                    </label>
                                    <input
                                      value={formik.values.accountNo}
                                      onChange={e => {
                                        formik.setFieldValue("accountNo", e.target.value);
                                      }}
                                      type="text"
                                      name=""
                                      class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                      placeholder="Type here"
                                    />
                                  </div>

                                  <div className="col mt-2.5">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Board Item
                                    </label>
                                    <input
                                      value={formik.values.boardItem}
                                      onChange={e => {
                                        formik.setFieldValue("boardItem", e.target.value);
                                      }}
                                      type="text"
                                      name=""
                                      class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                      placeholder="Type here"
                                    />
                                  </div>
                                  {/* 
                                  <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Services
                                    </label>
                                    <input
                                      value={formik.values.services}
                                      onChange={e => {
                                        formik.setFieldValue("services", e.target.value);
                                      }}
                                      name=""
                                      class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                      placeholder="Type here"
                                    />
                                  </div> */}
                                  <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      PSA Consultant's Name<span className=""></span>
                                    </label>
                                    <div className="">
                                      <input
                                        value={formik.values.submittedTo}
                                        onChange={e => {
                                          formik.setFieldValue("submittedTo", e.target.value);
                                        }}
                                        name="submittedTo"
                                        class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                        placeholder="Type here"
                                      />
                                    </div>
                                  </div>
                                  <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Personnel Action Reference No<span className=""></span>
                                    </label>
                                    <div className="">
                                      <input
                                        type="text"
                                        name="name"
                                        // value={formData?.referenceNo}
                                        value={formik.values.referenceNo}
                                        placeholder="Type here"
                                        onChange={e => {
                                          formik.setFieldValue("referenceNo", e.target.value);
                                        }}
                                        // defaultValue={formik.values.typeBE}
                                        class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                      />
                                    </div>
                                  </div>

                                </div>

                                <div className="">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    Agreement Date<span className="text-[red] pl-0.2">*</span>
                                  </label>
                                  <div className="relative custp-calender">
                                    <i
                                      className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"
                                      onClick={() => openCalendar("agreementDate")}
                                    ></i>
                                    <i
                                      className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"
                                      onClick={() => openCalendar("agreementDate")}
                                    ></i>
                                    <div className="card flex justify-content-center">
                                      <Calendar
                                        ref={inputRef2}
                                        value={formik.values.agreementDate}
                                        onChange={e => {
                                          formik.setFieldValue("agreementDate", e.target.value);
                                        }}
                                        onInput={(e) => validateDate(e)}
                                        placeholder="Start Date"
                                        className="w-full h-11"
                                        showClear
                                      />
                                    </div>
                                  </div>

                                  <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Effective Date<span className="text-[red] pl-0.2">*</span>
                                    </label>
                                    <div className="relative custp-calender">
                                      <i
                                        className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"
                                        onClick={() => openCalendar("effectiveDate")}
                                      ></i>
                                      <i
                                        className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"
                                        onClick={() => openCalendar("effectiveDate")}
                                      ></i>
                                      <div className="card flex justify-content-center">
                                        <Calendar
                                          ref={inputRef3}
                                          value={formik.values.effectiveDate}
                                          onChange={e => {
                                            formik.setFieldValue("effectiveDate", e.target.value);
                                            setEffectiveDate(e.target.value);
                                            handleEffectiveDateChange()
                                          }}
                                          onInput={(e) => validateDate(e)}
                                          placeholder="Start Date"
                                          className="w-full h-11"
                                          maxDate={formik.values.expireDate}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Review Date
                                    </label>
                                    <div className="relative custp-calender">
                                      <i
                                        className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"
                                        onClick={() => openCalendar("reviewDate")}
                                      ></i>
                                      <i
                                        className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"
                                        onClick={() => openCalendar("reviewDate")}
                                      ></i>
                                      <div className="card flex justify-content-center">
                                        <Calendar
                                          ref={inputRef5}
                                          value={formik.values.reviewDate}
                                          onChange={e => {
                                            formik.setFieldValue("reviewDate", e.target.value);
                                          }}
                                          onInput={(e) => validateDate(e)}
                                          placeholder="Start Date"
                                          className="w-full h-11"
                                        />
                                      </div>
                                    </div>
                                  </div> */}

                                  {/* <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Submitted to<span className="text-[red] pl-0.2">*</span>
                                    </label>
                                    <div className="">
                                      <Dropdown
                                        value={formik.values.submittedTo}
                                        onChange={e => {
                                          formik.setFieldValue("submittedTo", e.target.value);
                                        }}
                                        options={userData}
                                        optionLabel="name"
                                        placeholder="Select a Employee"
                                        filter
                                        className="w-full md:w-14rem"
                                      />
                                    </div>
                                  </div> */}

                                  <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Services
                                    </label>
                                    <textarea
                                      value={formik.values.services}
                                      onChange={e => {
                                        formik.setFieldValue("services", e.target.value);
                                      }}
                                      name=""
                                      rows="5"
                                      style={{ resize: "none" }}
                                      class="h-22 text-[16px] xl:text-[0.833vw] px-[14px] py-[12px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                      placeholder="Type here"
                                    ></textarea>

                                    {/* <input
                                      value={formik.values.services}
                                      onChange={e => {
                                        formik.setFieldValue("services", e.target.value);
                                      }}
                                      name=""
                                      class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                      placeholder="Type here"
                                    /> */}
                                  </div>

                                  <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Date of board meeting<span className="text-[red] pl-0.2">*</span>
                                    </label>
                                    <div className="relative custp-calender">
                                      <i
                                        className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"
                                        onClick={() => openCalendar("dateofboard")}
                                      ></i>
                                      <i
                                        className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"
                                        onClick={() => openCalendar("dateofboard")}
                                      ></i>
                                      <div className="card flex justify-content-center">
                                        <Calendar
                                          ref={inputRef4}
                                          value={formik.values.dateofboard}
                                          onChange={e => {
                                            formik.setFieldValue("dateofboard", e.target.value);
                                          }}
                                          onInput={(e) => validateDate(e)}
                                          placeholder="Start Date"
                                          className="w-full h-11"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      Page/ Item
                                    </label>
                                    <input
                                      value={formik.values.pageItem}
                                      onChange={e => {
                                        formik.setFieldValue("pageItem", e.target.value);
                                      }}
                                      name=""
                                      class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                      placeholder="Type here"
                                    />
                                  </div>

                                  <div className="col">
                                    <label
                                      className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                      for="username"
                                    >
                                      PSA Consultant's Email<span className="text-[red] pl-0.2">*</span>
                                    </label>
                                    <input
                                      value={formik.values.psaEmail}
                                      onChange={e => {
                                        formik.setFieldValue("psaEmail", e.target.value);
                                      }}
                                      disabled={psaCunsultentDisable}
                                      name="psaEmail"
                                      class="text-[16px] xl:text-[0.833vw] px-[14px] py-[9px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                      placeholder="Type here"
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 mt-[20px] xl:mt-[1.043vw] pb-[20px] xl:pb-[1.041vw]">
                          <div>
                            {/* <a
                              href="#"
                              className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium border border-[#D0D5DD] bg-white rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                            >
                              <i className="gusd-arrow-line-right mr-1"></i>Previous
                            </a> */}
                          </div>
                          <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                            {
                              superAdminEditor ? <></> :
                              <button
                              ref={saveBtnRef}
                              onClick={e => {
                                if(!superAdminEditor){
                                  saveBtnRef.current.disabled = true;
                                }
                                const dummFormData = { ...formData, ...formik.values };
                                saveBasicInfo("BasicInfo", dummFormData);
                                setShowPreviewPopUp(false);
                              }}
                              // href="javascript:void(0);"
                              className="inline-block text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium bg-[#EFF8FF]  border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                            >
                              <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Save
                            </button> 
                            }
                           
                            
                            {showPreviewPopUp ? (
                              <a
                                href="#"
                                onClick={() => {
                                  formik.handleSubmit();
                                  // saveBasicInfo();
                                  setConfirmVisible2(true);
                                  // setShowPreviewPopUp(true)
                                }}
                                className="flex text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                              >
                                <i className="gusd-check mr-1"></i>Submit
                              </a>
                            ) : (
                              <a
                                href="#"
                                onClick={() => {
                                  const dummFormData = { ...formData, ...formik.values };
                                  setFormData(dummFormData);
                                  const isBasicInfoValid = BasicInfoValidation(dummFormData);
                                  if (isBasicInfoValid) {
                                    // formik.handleSubmit()
                                    setShowPreviewPopUp(false);
                                    SetBasicInfoPopUp(false);
                                    setPartyDetailesPopUp(false);
                                    SetAttchmentAndDetailes(true);
                                    SetTermsAndConditions(false);
                                    SetW9Detailes(false);
                                    SetEddDetailes(false);
                                    // setSelectedSecondApprover("");
                                    // setSelectedFirstApprover("");
                                    // setSelectedThirdApprover("");
                                  }
                                }}
                                className="flex items-center text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                              >
                                <i className="gusd-check mr-1"></i>Next
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {partyDetailesPopup === true ? (
                      <div className="mt-[5px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]">
                        <div className="text-[#000000] font-medium xl:text-[1.406vw] text-[24px]">PSA Consultant Details</div>
                        <form>
                          <div className=" grid grid-cols-2 gap-x-8 xl:gap-y-[1.250vw] gap-y-[20px]">
                            <div className="">
                              <div className="col ">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  PSA Consultant's Name<span className="text-[red] pl-0.2">*</span>
                                </label>
                                <input
                                  onChange={e => {
                                    setParty(e.target.value)
                                    formik.setFieldValue("party", e.target.value);
                                  }}
                                  // defaultValue={formData?.party}
                                  defaultValue={formData.party ? formData?.party : formData?.submittedTo}
                                  type="text"
                                  name=""
                                  className="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                  placeholder="Type here"
                                />
                              </div>
                              <div className="col">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  Phone
                                </label>
                                <input
                                  onChange={e => {
                                    setPocNumber(e.target.value);
                                    formik.setFieldValue("pocNumber", e.target.value);
                                    // Ensure that the entered value contains only digits (0-9)
                                    const numericValue = e.target.value.replace(/\D/g, '');
                                    setFormData(prevData => ({ ...prevData, pocNumber: numericValue }));
                                  }}
                                  maxLength={'15'}
                                  value={formData?.pocNumber}
                                  type="text"
                                  name=""
                                  className="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                  placeholder="Type here"
                                />
                              </div>
                              <div className="col mt-1.5">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  Employer Identification
                                </label>
                                <input
                                  onChange={e => {
                                    setEmployerID(e.target.value)
                                    formik.setFieldValue("employerID", e.target.value);
                                  }}
                                  defaultValue={formData?.employerID}
                                  type="text"
                                  name=""
                                  class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                  placeholder="Type here"

                                />
                              </div>
                            </div>
                            <div className="">
                              <div className="col ">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  PSA Consultant's Email<span className="text-[red] pl-0.2">*</span>
                                </label>
                                <input
                                  onChange={e => {
                                    setPsaEmail(e.target.value)
                                    formik.setFieldValue("psaEmail", e.target.value);
                                  }}
                                  // defaultValue={formData?.email}
                                  defaultValue={formData?.psaEmail}
                                  type="text"
                                  name=""
                                  class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                  placeholder="Type here"
                                  disabled
                                />
                              </div>
                              <div className="col ">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  FAX
                                </label>

                                <input
                                  onChange={e => {
                                    setPocName(e.target.value)
                                    formik.setFieldValue("pocName", e.target.value);
                                  }}
                                  defaultValue={formData?.pocName}
                                  type="text"
                                  name=""
                                  class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                  placeholder="Type here"
                                />
                              </div>
                              <div className="col mt-1.5">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  Social Security Number
                                </label>
                                <input
                                  onChange={e => {
                                    setSsn(e.target.value);
                                    formik.setFieldValue("ssn", e.target.value);
                                  }}
                                  defaultValue={formData?.ssn}
                                  type="text"
                                  name=""
                                  class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                  placeholder="Type here"

                                />

                              </div>

                            </div>
                            {/* <label
                                className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                for="username"
                              >
                                Client ID<span className=""></span>
                              </label>
                              <input
                                onChange={e => {
                                  setClientId(e.target.value)
                                  formik.setFieldValue("clientId", e.target.value);
                                }}
                                defaultValue={formData?.clientId}
                                type="text"
                                name=""
                                class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                placeholder="Type here"

                              /> */}




                          </div>

                        </form>
                        <div className="mt-4">
                          <label
                            className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                            for="username"
                          >
                            Type of Business Entity
                          </label>
                          <div className="flex items-center gap-4">
                            <div className="flex">
                              <input
                                type="radio"
                                id="html"
                                name="fav_language"
                                value={BUSINESS_ENTITY.I}
                                // defaultChecked={formik.values.pSAPartyTypeBE === "Individual"}
                                onChange={(e) => {
                                  formik.setFieldValue("typeBE", e.target.value);
                                  setFormData(prevData => ({ ...prevData, typeBE: e.target.value }));
                                }}
                                defaultChecked={formData?.typeBE === BUSINESS_ENTITY.I}

                              // onChange={e => {
                              //   formik.setFieldValue("pSAPartyTypeBE", e.target.value);
                              // }}
                              />
                              <label
                                className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                for="username"
                              // onChange={e => {
                              //   formik.setFieldValue("pSAPartyTypeBE", e.target.value);
                              // }}

                              >
                                Individual
                              </label>
                            </div>
                            <div className="flex">
                              <input
                                type="radio"
                                id="html"
                                name="fav_language"
                                value={BUSINESS_ENTITY.SP}
                                onChange={(e) => {
                                  formik.setFieldValue("typeBE", e.target.value);
                                  setFormData(prevData => ({ ...prevData, typeBE: e.target.value }));
                                }}
                                // defaultChecked={formik.values.pSAPartyTypeBE === "Sole Partnership"}
                                defaultChecked={formData?.typeBE === BUSINESS_ENTITY.SP}
                              // onChange={e => {
                              //   formik.setFieldValue("pSAPartyTypeBE", e.target.value);
                              // }}

                              />
                              <label
                                className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                for="username"
                              >
                                Sole Partnership
                              </label>
                            </div>
                            <div className="flex">
                              <input
                                type="radio"
                                id="html"
                                name="fav_language"
                                value={BUSINESS_ENTITY.P}
                                onChange={(e) => {
                                  formik.setFieldValue("typeBE", e.target.value);
                                  setFormData(prevData => ({ ...prevData, typeBE: e.target.value }));
                                }}
                                // defaultChecked={formik.values.pSAPartyTypeBE === "Partnership"}
                                defaultChecked={formData?.typeBE === BUSINESS_ENTITY.P}
                              // onChange={e => {
                              //   formik.setFieldValue("pSAPartyTypeBE", e.target.value);
                              // }}

                              />
                              <label
                                className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                for="username"
                              >
                                Partnership
                              </label>
                            </div>
                            <div className="flex">
                              <input
                                type="radio"
                                id="html"
                                name="fav_language"
                                value={BUSINESS_ENTITY.C}
                                onChange={(e) => {
                                  formik.setFieldValue("typeBE", e.target.value);
                                  setFormData(prevData => ({ ...prevData, typeBE: e.target.value }));
                                }}
                                // defaultChecked={formik.values.pSAPartyTypeBE === "Corporation"}
                                defaultChecked={formData?.typeBE === BUSINESS_ENTITY.C}
                              // onChange={e => {
                              //   formik.setFieldValue("pSAPartyTypeBE", e.target.value);
                              // }}

                              />
                              <label
                                className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                for="username"
                              >
                                Corporation
                              </label>
                            </div>
                            {
                              console.log('formData?.typeBE', formData?.typeBE)
                            }
                            <div className="flex">
                              <input type="radio" id="html" name="fav_language" value=""
                                defaultChecked={
                                  ((formData?.typeBE === BUSINESS_ENTITY.I ||
                                    formData?.typeBE === BUSINESS_ENTITY.C ||
                                    formData?.typeBE === BUSINESS_ENTITY.P ||
                                    formData?.typeBE === BUSINESS_ENTITY.SP ||
                                    formData?.typeBE === undefined ||
                                    formData?.typeBE === null
                                  ) ?
                                    false : true)
                                }
                                onChange={(e) => {
                                  formik.setFieldValue("typeBE", e.target.value);
                                  setFormData(prevData => ({ ...prevData, typeBE: e.target.value }));
                                }}
                              />
                              <label
                                className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                                for="username"
                              >
                                Other
                              </label>
                            </div>

                            {
                              console.log('formik.values', formik.values)
                            }
                            {/* <div className="flex items-center gap-2">
                              <div>Other</div>
                            </div> */}

                            {(formData?.typeBE === BUSINESS_ENTITY.I ||
                              formData?.typeBE === BUSINESS_ENTITY.C ||
                              formData?.typeBE === BUSINESS_ENTITY.P ||
                              formData?.typeBE === BUSINESS_ENTITY.SP ||
                              formData?.typeBE === undefined ||
                              formData?.typeBE === null
                            ) ?
                              "" :
                              <div>
                                <input
                                  type="text"
                                  name="name"
                                  placeholder="Type here"
                                  defaultValue={
                                    (formData?.typeBE === BUSINESS_ENTITY.I ||
                                      formData?.typeBE === BUSINESS_ENTITY.C ||
                                      formData?.typeBE === BUSINESS_ENTITY.P ||
                                      formData?.typeBE === BUSINESS_ENTITY.SP ||
                                      formData?.typeBE === undefined
                                    ) ?
                                      "" : formData?.typeBE

                                  }
                                  onChange={(e) => {
                                    formik.setFieldValue("typeBE", e.target.value);
                                    setFormData(prevData => ({ ...prevData, typeBE: e.target.value }));
                                  }}
                                  // onChange={e => {
                                  //   formik.setFieldValue("pSAPartyTypeBE", e.target.value);
                                  // }}

                                  className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-[109px] leading-10"
                                />
                              </div>
                            }
                          </div>
                        </div>
                        <div className="mt-4 grid grid-cols-2 gap-8">
                          <div className="col">
                            <label
                              className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                              for="username"
                            >
                              Title
                            </label>
                            <input
                              type="text"
                              name=""
                              class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                              placeholder="Type here"
                              onChange={e => {
                                formik.setFieldValue("title", e.target.value);
                              }}
                              defaultValue={formData?.title}
                            />
                          </div>

                          <div className="col">
                            <label
                              className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                              for="username"
                            >
                              Licence Number
                            </label>
                            <input
                              type="text"
                              name=""
                              class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                              placeholder="Type here"
                              onChange={e => {
                                formik.setFieldValue("license", e.target.value);
                                setFormData(prevData => ({ ...prevData, license: e.target.value }));
                              }}

                              defaultValue={formData?.license}

                            />
                          </div>
                        </div>

                        <label
                          className="text-[#344054] text-[14px] mt-4 xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                          for="username"
                        >
                          Address
                        </label>
                        <div className="grid grid-cols-2 md:grid-cols-4 xl:gap-[1.250vw] gap-[20px]">
                          <div>
                            <input
                              type="text"
                              name="name"
                              placeholder="Street Address"
                              className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                              onChange={e => {
                                formik.setFieldValue("address", e.target.value);
                              }}
                              defaultValue={formData?.address}

                            />
                          </div>
                          <div>
                            <input
                              type="text"
                              name="name"
                              placeholder="City"
                              className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                              onChange={e => {
                                formik.setFieldValue("city", e.target.value);
                              }}
                              defaultValue={formData?.city}

                            />
                          </div>
                          <div>
                            <input
                              type="text"
                              name="name"
                              placeholder="State"
                              className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                              onChange={e => {
                                formik.setFieldValue("state", e.target.value);
                              }}
                              defaultValue={formData?.state}

                            />
                          </div>


                          <div>
                            <input
                              type="text"
                              name="name"
                              placeholder="Postal Code"
                              className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-full leading-10"
                              onChange={e => {
                                formik.setFieldValue("zip", e.target.value);
                              }}
                              defaultValue={formData?.zip}

                            />
                          </div>
                        </div>
                        <div className="mt-4 grid grid-cols-2 gap-8">

                          <div className="col">
                            <p>{partyDocuments.length ? "View Uploaded Document" : null}</p>

                            {partyDocuments.length ?
                              (
                                partyDocuments.map((res, index) => {
                                  return (
                                    <a
                                      href="#"
                                      onClick={() => {
                                        res?.filepath && OpenDocument(res?.filepath);
                                      }}
                                    >

                                      {res?.filename}
                                    </a>
                                  )

                                })
                              )
                              : null
                            }

                          </div>
                        </div>

                        <div className="grid grid-cols-2 mt-[40px] xl:mt-[2.083vw]">
                          <div>
                            <a
                              href="#"
                              onClick={() => {
                                setShowPreviewPopUp(false);
                                SetBasicInfoPopUp(false);
                                setPartyDetailesPopUp(false);
                                SetAttchmentAndDetailes(true);
                                SetTermsAndConditions(false);
                                SetW9Detailes(false);
                                SetEddDetailes(false);
                              }}
                              className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                            >
                              <i className="gusd-arrow-line-right mr-1"></i>Previous
                            </a>
                          </div>
                          <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                           
                          {
                              superAdminEditor ? <></>  :
                            <button
                              ref={saveBtnRef}
                              onClick={() => {
                                // formik.handleSubmit();
                                // saveBtnRef.current.disabled = true;
                                const dummFormData = { ...formData, ...formik.values };
                                setFormData(dummFormData)
                                saveBasicInfo("save", dummFormData);
                                // saveBasicInfo('save');
                                setShowPreviewPopUp(false);
                                /* setTimeout(() => {
                                  saveBtnRef.current.disabled = false;
                                }, 5000); */
                                // setShowNextPopUp(false);
                              }}
                              // href="javascript:void(0);"
                              // disabled={btnDisabled === true ? true : false}
                              className="inline-block text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium bg-[#EFF8FF] hover:bg-[#EFF8FF] border border-[#D0D5DD] hover:border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                            >
                              <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Save
                            </button>
}
                            {showPreviewPopUp ? (
                              <a
                                href="#"
                                onClick={() => {
                                  // saveBasicInfo();
                                  // setConfirmVisible2(true)
                                  // setShowPreviewPopUp(true)
                                }}
                                className="flex items-center text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                              >
                                <i className="gusd-check mr-1"></i>Submit
                              </a>
                            ) : (
                              <a
                                href="#"
                                onClick={() => {
                                  const dummFormData = { ...formData, ...formik.values };
                                  setFormData(dummFormData);
                                  setShowPreviewPopUp(false);
                                  SetBasicInfoPopUp(false);
                                  setPartyDetailesPopUp(false);
                                  SetAttchmentAndDetailes(false);
                                  SetTermsAndConditions(true);
                                  SetW9Detailes(false);
                                  SetEddDetailes(false);
                                }}
                                className="flex items-center text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                              >
                                <i className="gusd-check mr-1"></i>Next
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {attchmentAndDetailes === true ? (
                      <div className="h-[41vw] relative">
                        <div className="text-[#000000] font-medium xl:text-[1.406vw] text-[24px]">
                          Attachments & Notes
                        </div>
                        <label className="text-[#344054] ml-1  text-[12px] font-medium  inline-block" for="username">
                          Contract Document Lists
                        </label>
                        <div className="flex items-center gap-4">
                          <div className="flex">
                            <input
                              // type="radio"
                              type="checkbox"
                              id="html"
                              defaultChecked={formik.values.businessEntity?.includes("0")}
                              // defaultChecked={Array.isArray(formik?.values?.businessEntity) && formik?.values?.businessEntity?.includes("0")}
                              name="businessEntity"
                              onChange={e => {
                                if (formik.values.businessEntity) {
                                  if (formik.values.businessEntity?.includes("0")) {
                                    const data = formik.values.businessEntity?.filter(res => {
                                      if (res !== "0") {
                                        return res;
                                      }
                                    });
                                    formik.setFieldValue("businessEntity", data);
                                  } else {
                                    formik.setFieldValue("businessEntity", [...formik.values.businessEntity, "0"]);
                                  }
                                } else {
                                  formik.setFieldValue("businessEntity", ["0"]);
                                }
                              }}
                              value="0"
                            />
                            <label
                              className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                              for="username"
                            >
                              Scope of work
                            </label>
                          </div>
                          <div className="flex">
                            <input
                              // type="radio"
                              type="checkbox"
                              defaultChecked={formik.values.businessEntity?.includes("1")}
                              id="html"
                              name="businessEntity"
                              onChange={e => {
                                // formik.setFieldValue("businessEntity", e.target.value);
                                if (formik.values.businessEntity) {
                                  if (formik.values.businessEntity?.includes("1")) {
                                    const data = formik.values.businessEntity?.filter(res => {
                                      if (res !== "1") {
                                        return res;
                                      }
                                    });
                                    formik.setFieldValue("businessEntity", data);
                                  } else {
                                    formik.setFieldValue("businessEntity", [...formik.values.businessEntity, "1"]);
                                  }
                                } else {
                                  formik.setFieldValue("businessEntity", ["1"]);
                                }
                              }}
                              value="1"
                            />
                            <label
                              className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                              for="username"
                            >
                              Insurance Forms
                            </label>
                          </div>
                          <div className="flex">
                            <input
                              // type="radio"
                              type="checkbox"
                              defaultChecked={formik.values.businessEntity?.includes("2")}
                              id="html"
                              name="businessEntity"
                              onChange={e => {
                                if (formik.values.businessEntity) {
                                  if (formik.values.businessEntity?.includes("2")) {
                                    formik.setFieldValue("purchaseOrderNo", "");
                                    const data = formik.values.businessEntity?.filter(res => {
                                      if (res !== "2") {
                                        return res;
                                      }
                                    });
                                    formik.setFieldValue("businessEntity", data);
                                  } else {
                                    formik.setFieldValue("businessEntity", [...formik.values.businessEntity, "2"]);
                                  }
                                } else {
                                  formik.setFieldValue("businessEntity", ["2"]);
                                }
                              }}
                              value="2"
                            />
                            <label
                              className="text-[#344054] ml-1  text-[12px] font-medium  inline-block"
                              for="username"
                            >
                              Purchase Order No.
                            </label>
                          </div>
                          <div>
                            {formik.values.businessEntity?.includes("2") ? (
                              <input
                                type="text"
                                name="name"
                                placeholder="Type here"
                                onChange={e => {
                                  formik.setFieldValue("purchaseOrderNo", e.target.value);
                                }}
                                defaultValue={formData?.purchaseOrderNo}
                                value={formik.values.purchaseOrderNo}
                                className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-[109px] leading-10"
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="flex items-center gap-2 mt-6">
                          <div className="flex">
                            <input
                              // type="radio"
                              type="checkbox"
                              id="html"
                              // name="checkboxName"
                              name="businessEntity"
                              defaultChecked={formik.values.businessEntity?.includes("3")}
                              value="3"
                              onChange={e => {
                                if (formik.values.businessEntity) {
                                  if (formik.values.businessEntity?.includes("3")) {
                                    const data = formik.values.businessEntity?.filter(res => {
                                      if (res !== "3") {
                                        return res;
                                      }
                                    });
                                    formik.setFieldValue("businessEntity", data);
                                  } else {
                                    formik.setFieldValue("businessEntity", [...formik.values.businessEntity, "3"]);
                                  }
                                } else {
                                  formik.setFieldValue("businessEntity", ["3"]);
                                }
                                // formik.setFieldValue("checkboxName", e.target.value);
                              }}
                            />
                            <label
                              className="text-[#344054] ml-1  text-[12px] font-medium  flex items-center"
                              for="username"
                            >
                              Addendum Containing Specific Terms and Conditions
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              // type="radio"
                              type="checkbox"
                              defaultChecked={formik.values.businessEntity?.includes("4")}
                              id="html"
                              // onChange={e => {
                              //   formik.setFieldValue("businessEntity", e.target.value);
                              // }}
                              // name="checkboxName"
                              name="businessEntity"
                              onChange={e => {
                                // formik.setFieldValue("checkboxName", e.target.checked);
                                if (formik.values.businessEntity) {
                                  if (formik.values.businessEntity?.includes("4")) {
                                    formik.setFieldValue("addendumNo", "");
                                    const data = formik.values.businessEntity?.filter(res => {
                                      if (res !== "4") {
                                        return res;
                                      }
                                    });
                                    formik.setFieldValue("businessEntity", data);
                                  } else {
                                    formik.setFieldValue("businessEntity", [...formik.values.businessEntity, "4"]);
                                  }
                                } else {
                                  formik.setFieldValue("businessEntity", ["4"]);
                                }
                              }}
                              value="4"
                            />
                            <div className="flex items-center">
                              <div>
                                <label
                                  className="text-[#344054] ml-1  text-[12px] font-medium  flex items-center"
                                  for="username"
                                >
                                  Attached Addendum No.
                                </label>
                              </div>
                              <div>
                                {formik.values.businessEntity?.includes("4") ? (
                                  <input
                                    type="text"
                                    // name="checkboxName"
                                    onChange={e => {
                                      formik.setFieldValue("addendumNo", e.target.value);
                                      // alert("watch")
                                    }}
                                    defaultValue={formData?.addendumNo}
                                    value={formik.values.addendumNo}
                                    placeholder="Type here"
                                    className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-[109px] leading-10"
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                              {/* {
                                formik.values.businessEntity?.includes("4") ?
                                  <input
                                    type="text"
                                    name="name"
                                    placeholder="Type here"
                                    onChange={e => {
                                      // formik.setFieldValue("purchaseOrderNo", e.target.value);
                                    }}
                                    defaultValue={formData?.purchaseOrderNo}
                                    // defaultValue={formik.values.businessEntity}
                                    className="bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] ml-2 p-[10px] placeholder:text-[#667085] placeholder:text-xs w-[109px] leading-10"
                                  /> : null

                              } */}
                            </div>
                          </div>
                        </div>

                        <div className="col mt-6">
                          <label className="text-[#344054] ml-1  text-[12px] font-medium  inline-block" for="username">
                            Notes<span className=""></span>
                          </label>
                          <input
                            onChange={e => {
                              formik.setFieldValue("notes", e.target.value);
                            }}
                            type="text"
                            defaultValue={formik.values.notes}
                            name="notes"
                            class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                            placeholder="Note"
                          />
                        </div>

                        <div className="col mt-6">
                          <label className="text-[#344054] ml-1  text-[12px] font-medium  inline-block" for="username">
                            Other Remarks<span className=""></span>
                          </label>
                          <input
                            onChange={e => {
                              formik.setFieldValue("otherRemark", e.target.value);
                            }}
                            type="text"
                            name="otherRemark"
                            defaultValue={formik.values.otherRemark}
                            class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                            placeholder="Other Remarks"
                          />
                        </div>

                        <div className="mt-6">


                          {initiatorDocuments.length > 0 ?
                            (
                              initiatorDocuments.map((res, index) => {

                                return (
                                  // <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
                                  <h5>
                                    <p className="psa-attachments-notes-remove-btn" style={{ cursor: "pointer" }} >
                                      <a href="#" onClick={() => {
                                        res?.filepath && OpenDocument(res?.filepath);
                                      }}
                                      >
                                        {res?.filename}{" "}
                                      </a>
                                      {
                                        <Button
                                          icon="pi pi-times"
                                          onClick={() => {
                                            onClickRemoveDoc(index)
                                            // setFileName(prev => {
                                            //   return prev.filter(res1 => {
                                            //     if (res1 != res) {
                                            //       return res1;
                                            //     }
                                            //   });
                                            // });
                                          }}
                                          rounded
                                          text
                                          severity="danger"
                                          aria-label="Cancel"
                                        />
                                      }
                                    </p>
                                  </h5>
                                  // </div>
                                );
                              })

                            )
                            : null
                          }

                          <div class=" h-auto">


                            <>
                              <div className="border border-dashed border-gray-500 relative">
                                <input
                                  type="file"
                                  name="filename"
                                  ref={inputFile}
                                  class="cursor-pointer block opacity-0 w-full h-[100px] relative " style={{ zIndex: 9999999 }}
                                  multiple
                                  onChange={e => {
                                    uploadDocuments(e);
                                  }}
                                />
                                <div class="text-center m-auto my-5 absolute left-0 z-50 right-0 top-[3%]">

                                  <h4>
                                    Drop files anywhere to upload
                                    <br />
                                    or
                                  </h4>
                                  <p class="">Select Files</p>
                                </div>

                              </div>


                              <div className="text-center m-auto mt-[20px] h-[100px] overflow-auto">
                                <div className="grid grid-cols-2 md:grid-cols-2 gap-3 xl:gap-[0.250vw]">
                                  {fileName.length > 0 &&
                                    fileName.map(res => (
                                      <p className="psa-attachments-notes-remove-btn text-[12px] h-[30px]">
                                        {res}{" "}
                                        {
                                          <Button
                                            icon="pi pi-times"
                                            onClick={() => {
                                              setFileName(prev => {
                                                return prev.filter(res1 => {
                                                  if (res1 != res) {
                                                    return res1;
                                                  }
                                                });
                                              });



                                              setDocList(prev => {
                                                return prev.filter(res1 => {
                                                  if (res1.filename != res) {
                                                    return res1;
                                                  }
                                                });
                                              });


                                            }}
                                            rounded
                                            text
                                            severity="danger"
                                            aria-label="Cancel"
                                          />
                                        }
                                      </p>
                                    ))}
                                </div>
                              </div>

                            </>




                          </div>
                        </div>

                        <div className="col mt-6"></div>

                        <div className="bottom-0 right-0 left-0 grid grid-cols-2 mt-[60px] xl:mt-[4.083vw]">
                          <div>
                            <a
                              href="#"
                              onClick={() => {
                                setShowPreviewPopUp(false);
                                SetBasicInfoPopUp(true);
                                setPartyDetailesPopUp(false);
                                SetAttchmentAndDetailes(false);
                                SetTermsAndConditions(false);
                                SetW9Detailes(false);
                                SetEddDetailes(false);
                              }}
                              className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                            >
                              <i className="gusd-arrow-line-right mr-1"></i>Previous
                            </a>
                          </div>
                          <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">

                           {
                            superAdminEditor ? <></>  :
                            <button
                            // href="javascript:void(0);"
                            ref={saveBtnRef}
                            onClick={() => {
                              if(!superAdminEditor){
                                saveBtnRef.current.disabled = true;
                              }
                              formik.handleSubmit();
                              /*  setTimeout(() => {
                                 saveBtnRef.current.disabled = false;
                               }, 5000); */
                              // saveBasicInfo('save');
                            }}
                            className="flex items-center text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium bg-[#EFF8FF] hover:bg-[#EFF8FF] border border-[#D0D5DD] hover:border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                          >
                            <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Save
                          </button> 
                           }
                           
                           
                            {showPreviewPopUp ? (
                              <a
                                href="#"
                                onClick={() => {
                                  formik.handleSubmit();
                                  saveBasicInfo();
                                  setConfirmVisible2(true);
                                }}
                                className="flex text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                              >
                                <i className="gusd-check mr-1"></i>Submit
                              </a>
                            ) : (
                              <a
                                href="#"
                                onClick={() => {
                                  const dummFormData = { ...formData, ...formik.values };
                                  setFormData(dummFormData);
                                  // formik.handleSubmit()
                                  setShowPreviewPopUp(false);
                                  SetBasicInfoPopUp(false);
                                  setPartyDetailesPopUp(isEdit ? true : false);
                                  SetAttchmentAndDetailes(false);
                                  SetTermsAndConditions(!isEdit ? true : false);
                                  SetW9Detailes(false);
                                  SetEddDetailes(false);
                                }}
                                className="flex items-center text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                              >
                                <i className="gusd-check mr-1"></i>Next
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {termsAndConditions === true ? (
                      <div className="relative h-full">
                        <div className="card termsandcondition psascroll">
                          <TabView>
                            <TabPanel header="Terms & Conditions">
                              <PsaTermsAndConditions TandC="true" checkBox={isApproverEdit} />
                            </TabPanel>
                            <TabPanel header="Supplemental Agreement">
                              <PsaTermsAndConditions supplimentAndAgreement="true" checkBox={isApproverEdit} />
                            </TabPanel>
                            <TabPanel header="Hold Harmless and Indemnification Agreement">
                              <PsaTermsAndConditions HoldHarmlessAndIden="true" checkBox={isApproverEdit} />
                            </TabPanel>
                            <TabPanel header="Retirement Status Statement">
                              <PsaTermsAndConditions retiretmentStatus="true" checkBox={isApproverEdit} strs={formData?.strs}
                                calpers={formData?.calpers}
                              />
                            </TabPanel>
                            <TabPanel header="Certification Regarding Governor  Executive order N-6-22">
                              <PsaTermsAndConditions certificationRegarding="true" checkBox={isApproverEdit} />
                            </TabPanel>
                            <TabPanel header="EDD & W9 Details">
                              <PsaTermsAndConditions eddw9="true" checkBox={isApproverEdit} pSAPartyFileName={formData?.pSAPartyFileName} psaConsultantId={formData?.psaConsultantId} pSAPartyFileName2={formData?.pSAPartyFileName2} />
                            </TabPanel>
                          </TabView>
                        </div>
                      </div>
                    ) : null}
                    {eddDetailes === true ? (
                      <div>
                        <div className="text-[#000000] font-medium xl:text-[1.406vw] text-[24px]">Routing</div>
                        <form>
                          <div className="mt-2 grid grid-cols-1 gap-8 clearicons">
                            <div className="space-y-[20px]">
                              <div className="col ">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  Budget Clerk :
                                </label>
                                <div className="relative">
                                  <div className="absolute left-3 top-2">
                                    <i className="gusd-user"></i>
                                  </div>
                                  {/*<input value={selectedItem}  onChange={handleKeyUp} class="border border-[#E4E7EC] bg-white h-10 px-5 pl-10 pr-16 w-full rounded-lg text-sm focus:outline-none" type="search" name="search" placeholder="Search" /> */}
                                  <Dropdown
                                    id="dept"
                                    // disabled={superAdminEditor}
                                    // value={selectedFirstApprover}
                                    value={
                                      formik.values.budgetClerk ? formik.values.budgetClerk : selectedFirstApprover
                                    }
                                    // value={{
                                    //   code: "c7eea0c2-9c89-46e7-b297-5e077767585b",
                                    //   email: "aghate@hexalytics.com",
                                    //   name: "Abhishek Ghate (PA0001)",
                                    //   role: "Payroll"
                                    // }}
                                    onChange={e => {
                                      formik.setFieldValue("budgetClerk", e.value);
                                      setSelectedFirstApprover(e.value);
                                    }}
                                    filter

                                    name="budgetClerk"
                                    onKeyDown={e => {
                                      setApproverList(e);
                                    }}
                                    valueTemplate={selectedCountryTemplate}
                                    disabled={budgetClerkDisabled}
                                    placeholder="Type to Search"
                                    options={allApproverList.length > 0 ? allApproverList : userData}
                                    optionLabel="name"
                                    // name="budgetClerk"
                                    className="w-full h-11 rounded-lg border border-[#E4E7EC] pl-5"
                                    style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
                                  />

                                  {/* <AutoComplete
                                    value={budgetClerk}
                                    inputClassName={"custom-autocomplete-input"}
                                    className="border border-[#E4E7EC] bg-white h-10 px-5 pl-10 pr-16 w-full rounded-lg text-sm focus:outline-none"
                                    type="search"
                                    name="search"
                                    placeholder="Search"
                                    suggestions={items}
                                    completeMethod={handleKeyUp}
                                    onChange={e => setBudgetClerk(e.value)}
                                  />
                                  <div className="absolute right-3 bottom-2">
                                    <i className="gusd-search"></i>
                                  </div> */}
                                </div>
                              </div>
                              {/* add budget manager start */}

                              <div className="col ">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  Budget manager :{(selectedFirstApprover != "") ? <span className="text-[red] pl-0.2">*</span> : null}
                                </label>
                                <div className="relative">
                                  <div className="absolute left-3 top-2">
                                    <i className="gusd-user"></i>
                                  </div>
                                  <Dropdown
                                    id="dept"
                                    showClear
                                    value={
                                      formik.values.budgetManager ? formik.values.budgetManager : selectedBudgetManagerApprover
                                    }
                                    onChange={e => {
                                      formik.setFieldValue("budgetManager", e.value);
                                      setSelectedBudgetManagerApprover(e.value);
                                    }}
                                    filter
                                    name="budgetManager"
                                    onKeyDown={e => {
                                      setApproverList(e);
                                    }}
                                    disabled={budgetManagerDisabled}
                                    // disabled={superAdminEditor? true : formik.values.budgetClerk ? false : true}
                                    placeholder={(selectedFirstApprover != "") ? "Select Budget Manager" : "Select Budget Clerk First"}
                                    options={allApproverList.length > 0 ? allApproverList : userData}
                                    optionLabel="name"
                                    className="w-full h-11 rounded-lg border border-[#E4E7EC] pl-5"
                                    style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
                                  />
                                </div>
                              </div>
                              {/* add budget manager end */}

                              {/* <div className="col ">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  HR Consultant Clearance Verification :<span className="text-[red] pl-0.2">*</span>
                                </label>
                                <div className="relative">
                                  <div className="absolute left-3 top-2">
                                    <i className="gusd-user"></i>
                                  </div>
                                  
                                  <Dropdown
                                    id="dept"
                                    value={
                                      formik.values.hrConsultant ? formik.values.hrConsultant : selectedSecondApprover
                                    }
                                    // showClear
                                    onChange={e => {
                                      formik.setFieldValue("hrConsultant", e.value);
                                      setSelectedSecondApprover(e.value);
                                    }}
                                    filter
                                    onKeyDown={e => {
                                      setApproverList(e);
                                    }}
                                    // disabled={isEmpDisable ? isEmpDisable : disabled}
                                    options={allApproverList.length > 0 ? allApproverList : userData}
                                    optionLabel="name"
                                    placeholder="Type to Search"
                                    name="hrConsultant"
                                    className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5"
                                    style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
                                  />
							
                                  
                                </div>
					</div>*/}


                              <div className="col ">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  Executive Approver (After Board Approval) :
                                  <span className="text-[red] pl-0.2">*</span>
                                </label>
                                <div className="relative">
                                  <div className="absolute left-3 top-2">
                                    <i className="gusd-user"></i>
                                  </div>
                                  {/*<input class="border border-[#E4E7EC] bg-white h-10 px-5 pl-10 pr-16 w-full rounded-lg text-sm focus:outline-none" type="search" name="search" placeholder="Search" /> */}
                                  <Dropdown
                                    showClear
                                    id="dept"
                                    name="executive"
                                    value={formik.values.executive ? formik.values.executive : selectedThirdApprover}
                                    onChange={e => {
                                      formik.setFieldValue("executive", e.value);
                                      setSelectedThirdApprover(e.value);
                                    }}
                                    filter
                                    onKeyDown={e => {
                                      setApproverList(e);
                                    }}
                                    disabled={executiveApproverDisabled}
                                    // disabled={isEmpDisable ? isEmpDisable : disabled}
                                    options={allApproverList.length > 0 ? allApproverList : userData}
                                    // showClear
                                    optionLabel="name"
                                    placeholder="Type to Search"
                                    className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5"
                                    style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
                                  />
                                  {/* <AutoComplete
                                    value={executiveApprover}
                                    inputClassName={"custom-autocomplete-input"}
                                    className="border border-[#E4E7EC] bg-white h-10 px-5 pl-10 pr-16 w-full rounded-lg text-sm focus:outline-none"
                                    type="search"
                                    name="search"
                                    placeholder="Search"
                                    suggestions={items}
                                    completeMethod={handleKeyUp}
                                    onChange={e => setExecutiveApprover(e.value)}
                                  />
                                  <div className="absolute right-3 bottom-2">
                                    <i className="gusd-search"></i>
                                  </div> */}
                                </div>
                              </div>

                              <div className="col ">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  HR Executive Secretary :<span className="text-[red] pl-0.2">*</span>
                                </label>
                                <div className="relative">
                                  <div className="absolute left-3 top-2">
                                    <i className="gusd-user"></i>
                                  </div>
                                  {/* <input class="border border-[#E4E7EC] bg-white h-10 px-5 pl-10 pr-16 w-full rounded-lg text-sm focus:outline-none" type="search" name="search" placeholder="Search" /> */}
                                  <Dropdown
                                    showClear
                                    id="dept"
                                    name="hrexecutive"
                                    // disabled={superAdminEditor}
                                    value={formik.values.hrexecutive ? formik.values.hrexecutive : selectedPayroll}
                                    onChange={e => {
                                      formik.setFieldValue("hrexecutive", e.value);
                                      setSelectedPayroll(e.value);
                                      formik.setFieldValue("hrConsultant", e.value);
                                      setSelectedSecondApprover(e.value);
                                    }}
                                    filter
                                    onKeyDown={e => {
                                      setApproverList(e);
                                    }}
                                    disabled={hrExecutiveSecretaryDisabled}
                                    options={allApproverList.length > 0 ? allApproverList : userData}
                                    optionLabel="name"
                                    placeholder="Type to Search"
                                    className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5"
                                    style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
                                  />
                                  {/* <AutoComplete
                                    value={hrSecreatary}
                                    inputClassName={"custom-autocomplete-input"}
                                    className="border border-[#E4E7EC] bg-white h-10 px-5 pl-10 pr-16 w-full rounded-lg text-sm focus:outline-none"
                                    type="search"
                                    name="search"
                                    placeholder="Search"
                                    suggestions={items}
                                    completeMethod={handleKeyUp}
                                    onChange={e => setHrSecreatary(e.value)}
                                  />
                                  <div className="absolute right-3 bottom-2">
                                    <i className="gusd-search"></i>
                                  </div> */}
                                </div>
                              </div>
                              <div className="col">
                                <label
                                  className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                  for="username"
                                >
                                  Submit Completed form to :<span className=""></span>
                                </label>
                                <div className="">
                                  <input
                                    value={formik.values.submittedCompletedFormTo}
                                    onChange={e => {
                                      formik.setFieldValue("submittedCompletedFormTo", e.target.value);
                                    }}
                                    disabled={psaCunsultentDisable}
                                    name="submittedCompletedFormTo"
                                    class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                    placeholder="Type here"
                                  />
                                </div>
                              </div>
                              {/* <div className='col '>
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Submit Completed form to :<span className='text-[red] pl-0.2'>*</span></label>
                                  <div className="relative">
                                  <div className="absolute left-3 top-2"><i className="gusd-user"></i></div>
                                  <input class="border border-[#E4E7EC] bg-white h-10 px-5 pl-10 pr-16 w-full rounded-lg text-sm focus:outline-none" type="search" name="search" placeholder="Search" />
                                  <div className="absolute right-3 bottom-2"><i className="gusd-search"></i></div>
                                  </div>
                                  </div> */}
                            </div>
                          </div>

                          <div className="grid grid-cols-2 mt-[5vw]  xl:mt-[2.083vw]">
                            <div>
                              <a
                                href="#"
                                onClick={() => {
                                  setShowPreviewPopUp(false);
                                  SetBasicInfoPopUp(false);
                                  setPartyDetailesPopUp(false);
                                  SetAttchmentAndDetailes(false);
                                  SetTermsAndConditions(true);
                                  SetW9Detailes(false);
                                  SetEddDetailes(false);
                                }}
                                className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="gusd-arrow-line-right mr-1"></i>Previous
                              </a>
                            </div>
                            <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                            {
                            superAdminEditor ? <></>  :
                              <button
                                ref={saveBtnRef}
                                type="button"
                                onClick={() => {
                                  if(!superAdminEditor){
                                    saveBtnRef.current.disabled = true;
                                  }
                                  // formik.handleSubmit();
                                  // setShowNextPopUp(false);
                                  const dummFormData = { ...formData, ...formik.values };
                                  saveBasicInfo("routing", dummFormData);
                                  // setShowPreviewPopUp(false);
                                  /*  setTimeout(() => {
                                     saveBtnRef.current.disabled = false;
                                   }, 2000); */
                                }}
                                // href="javascript:void(0);"
                                className="flex items-center text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium bg-[#EFF8FF] hover:bg-[#EFF8FF] border border-[#D0D5DD] hover:border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                              >
                                <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Save
                              </button>
}

                              {showPreviewPopUp ? (
                                <a
                                  href="#"
                                  onClick={() => {
                                    saveBasicInfo();
                                    setConfirmVisible2(true);
                                    // setShowPreviewPopUp(true)
                                  }}
                                  className="flex items-center text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Submit
                                </a>
                              ) : (
                                <a
                                  href="#"
                                  onClick={() => {
                                    const dummFormData = { ...formData, ...formik.values };
                                    setFormData(dummFormData);
                                    const isRoutingInfoValid = routingValidation(dummFormData);
                                    if (isRoutingInfoValid) {
                                      setShowPreviewPopUp(true);
                                      SetBasicInfoPopUp(false);
                                      setPartyDetailesPopUp(false);
                                      SetAttchmentAndDetailes(false);
                                      SetTermsAndConditions(false);
                                      SetW9Detailes(false);
                                      SetEddDetailes(false);
                                      SetPreviewAndEdit(true);
                                    }
                                  }}
                                  className="flex items-center text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="gusd-check mr-1"></i>Next
                                </a>
                              )}
                            </div>
                          </div>
                        </form>
                      </div>
                    ) : null}
                    {w9Detailes === true ? (
                      <div>
                        <div className="text-[24px] xl:text-[1.250vw] font-medium">W9 Details</div>
                        <Image src={w9DetailesPic} imageClassName="ml-6" alt="user" width="550" height="370" />
                        <div className="w-full flex justify-center text-[#101828] text-[16px] mt-4">
                          Department of the Treasury Internal Revenue Service
                        </div>
                        <div className="grid grid-cols-2 mt-[6vw]">
                          <div>
                            <a
                              href="#"
                              onClick={() => {
                                setShowPreviewPopUp(false);
                                SetBasicInfoPopUp(false);
                                setPartyDetailesPopUp(false);
                                SetAttchmentAndDetailes(false);
                                SetTermsAndConditions(false);
                                SetW9Detailes(false);
                                SetEddDetailes(true);
                              }}
                              className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                            >
                              <i className="gusd-arrow-line-right mr-1"></i>Previous
                            </a>
                          </div>
                          <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                          {
                            superAdminEditor ? <></> :
                           
                            <a
                              // onClick={() => {
                              //   setShowNextPopUp(false);
                              // }}
                              href="javascript:void(0);"
                              className="flex items-center text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#26be13] hover:bg-[#23a512] border border-[#26be13] hover:border-[#23a512] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                            >
                              <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Save
                            </a>
}
                            
                            {showPreviewPopUp ? (
                              <a
                                href="#"
                                onClick={() => {
                                  // saveBasicInfo();
                                  // setConfirmVisible2(true)
                                  // // setShowPreviewPopUp(true)
                                }}
                                className="flex text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                              >
                                <i className="gusd-check mr-1"></i>Submit
                              </a>
                            ) : (
                              <a
                                href="#"
                                onClick={() => {
                                  setShowPreviewPopUp(true);
                                  SetBasicInfoPopUp(false);
                                  setPartyDetailesPopUp(false);
                                  SetAttchmentAndDetailes(false);
                                  SetTermsAndConditions(false);
                                  SetW9Detailes(false);
                                  SetEddDetailes(false);
                                }}
                                className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                              >
                                <i className="gusd-eye mr-1"></i>Preview
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {previewAndEdit === true ? (
                      <div>
                        <div className="text-[#000000] font-medium xl:text-[1.406vw] text-[24px]">Preview & Edit</div>
                        <div className="flex  justify-end xl:mt-[1.667vw] mt-[28px]">
                          <div
                            className="bg-[#EFF8FF] border border-[#EFF8FF] rounded-lg text-[#113699] font-medium text-sm py-[6px] px-3 flex items-center space-x-2 cursor-pointer"
                            onClick={() => {
                              // generatePDF()
                              // toPDF();
                              setLoaderPdf(true)
                              childRef.current.generatePDF();
                            }}
                          >
                            <i className="Icon01 uploading_blue"></i>
                            {
                              loaderPdf === true ?
                                <span>Please Wait...</span>
                                :
                                <>
                                  <span>Export Pdf</span>
                                </>
                            }

                          </div>
                        </div>
                        <div className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]">
                          {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                          <div id="pdfReport">
                            <PsaPdf
                              isApproverEdit={isApproverEdit}
                              ref={childRef}
                              setLoaderPdf={setLoaderPdf}
                              agreementDate={formData?.agreementDate}
                              partyName={formData.party ? formData?.party : formData?.submittedTo}
                              amount={formData?.amount}
                              services={formData?.services}
                              effectiveDate={formData?.effectiveDate}
                              expirationDate={formData?.expireDate}
                              typeOfBusinessEntityAandN={formData?.businessEntity}
                              submittedTo={formData?.submittedTo?.name}
                              referenceNo={formData?.referenceNo}
                              purchaseOrderNo={formData?.purchaseOrderNo}
                              addendumNo={formData?.addendumNo}
                              businessEntity={formData.businessEntity}
                              typeBE={formData?.typeBE}
                              otherTypeBE={pSAPartyData?.otherTypeBE}
                              pocNumber={formData?.pocNumber}
                              // PSA Consultant details
                              typeOfBusinessEntityPartyDetails={formData?.typeOfBusinessEntityPartyDetails}
                              title={formData?.title}
                              licenseNumber={formData.licenseNumber ? formData?.licenseNumber : formData?.license}
                              addressPSa={
                                `${formData?.state ? formData?.state : ""
                                }
                                ${formData?.city ? formData.city : ""} 
                                ${formData?.address ? formData?.address : ""}
                               ${formData?.zip ? formData?.zip : ""}
                                `}
                              psaDate={formData?.psaDate}
                              contactNumber={formData?.contactNumber}
                              fax={formData?.pocName}
                              //Tax Identification Details
                              socialSecurityNumber={formData?.ssn}
                              employerIdentification={formData?.employerID}
                              //Gusd Detailes
                              gusdDate={formData?.gusdDate}
                              accountNumber={formData?.accountNo}
                              dateOfBoardMeeting={formData?.dateofboard}
                              BoardItem={formData?.boardItem}
                              pageItem={formData?.pageItem}
                              superintendentAssistent={formData?.superintendentAssistent}
                              submittedCompletedFormTo={formData?.submittedCompletedFormTo}
                              dateOfApprove={formData?.dateOfApprove}

                              strs={formData?.strs}
                              calpers={formData?.calpers}

                              updatedAt={formData?.psaPatyUpdatedDate}

                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-2 mt-[40px] xl:mt-[2.083vw] pb-[20px] xl:pb-[1.041vw]">
                          <div>
                            <a
                              href="#"
                              onClick={() => {
                                setShowPreviewPopUp(false);
                                SetBasicInfoPopUp(false);
                                setPartyDetailesPopUp(false);
                                SetAttchmentAndDetailes(false);
                                SetTermsAndConditions(false);
                                SetW9Detailes(false);
                                SetEddDetailes(true);
                                SetPreviewAndEdit(false);
                              }}
                              className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                            // className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium border border-[#EFF8FF] bg-[#3366FF] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                            >
                              {/* <i className="gusd-eye mr-1"></i>Preview */}
                              <i className="gusd-arrow-line-right mr-1"></i>Previous
                            </a>
                          </div>
                          <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                          {
                            superAdminEditor ? <></> :
                            
                            <button
                              ref={saveBtnRef}
                              onClick={() => {
                                if(!superAdminEditor){
                                  saveBtnRef.current.disabled = true;
                                }
                                // formik.handleSubmit();
                                // setShowNextPopUp(false);
                                const dummFormData = { ...formData, ...formik.values };
                                // setFormData(dummFormData);
                                saveBasicInfo("save", dummFormData);
                                // toast.success("Data Updated Successfully.");
                                //SetBasicInfoPopUp(true)  //comment for #359
                                setShowPreviewPopUp(false);
                                //SetPreviewAndEdit(false); //comment for #359
                                /* setTimeout(() => {
                                  saveBtnRef.current.disabled = false;
                                }, 5000); */
                              }}
                              disabled={btnDisabled === true ? true : false}
                              href="javascript:void(0);"
                              className="flex items-center text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium bg-[#EFF8FF] hover:bg-[#EFF8FF] border border-[#D0D5DD] hover:border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                            >
                              <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Save
                            </button>
                            
}
                            <button
                              // ref={saveBtnRef}
                              onClick={() => {
                                if(!superAdminEditor){
                                  saveBtnRef.current.disabled = true;
                                }
                                const dummFormData = { ...formData, ...formik.values };
                                setFormData(dummFormData);
                                saveBasicInfo("submit", dummFormData);
                                //SetBasicInfoPopUp(true)   //comment for issue #359
                                // SetBasicInfoPopUp(true)
                                setShowPreviewPopUp(false);
                                // SetPreviewAndEdit(false);  //comment for issue  #359
                                // setTimeout(() => {

                                //   saveBtnRef.current.disabled = false;
                                // }, 5000);
                                // setConfirmVisible2(true);
                                // setShowPreviewPopUp(true)
                              }}
                              className="flex text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                            >
                              <i className="gusd-check mr-1"></i>{(btnDisabled) ? "Please Wait" : "Submit"}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {termsAndConditions === true ? (
                    <div className="bg-white py-5 px-2">
                      <div className="absolute bottom-5 right-10 left-10 grid grid-cols-2  ">
                        <div>
                          <a
                            href="#"
                            onClick={() => {
                              setShowPreviewPopUp(false);
                              SetBasicInfoPopUp(false);
                              setPartyDetailesPopUp(isEdit ? true : false);
                              SetAttchmentAndDetailes(!isEdit ? true : false);
                              SetTermsAndConditions(false);
                              SetW9Detailes(false);
                              SetEddDetailes(false);
                            }}
                            className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                          >
                            <i className="gusd-arrow-line-right mr-1"></i>Previous
                          </a>
                        </div>
                        <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                        {
                            superAdminEditor ? <></> :
                          
                          <button
                            // href="javascript:void(0);"
                            ref={saveBtnRef}
                            onClick={e => {
                              // formik.handleSubmit();
                              if(!superAdminEditor){
                                saveBtnRef.current.disabled = true;
                              }

                              const dummFormData = { ...formData, ...formik.values };
                              saveBasicInfo("save", dummFormData);
                              // saveBasicInfo('save');
                              setShowPreviewPopUp(false);
                              /* setTimeout(() => {
                                saveBtnRef.current.disabled = false;
                              }, 5000); */
                              // setShowNextPopUp(false);
                            }}
                            className="flex items-center text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium bg-[#EFF8FF] hover:bg-[#EFF8FF] border border-[#D0D5DD] hover:border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                          >
                            <i className="pi pi-save mr-1" style={{ fontSize: "0.8rem" }}></i>Save
                          </button>
}

                          {showPreviewPopUp ? (
                            <a
                              href="#"
                              onClick={() => {
                                saveBasicInfo();
                                setConfirmVisible2(true);

                              }}
                              className="flex items-center text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                            >
                              <i className="gusd-check mr-1"></i>Submit
                            </a>
                          ) : (
                            <a
                              href="#"
                              onClick={() => {
                                setShowPreviewPopUp(false);
                                SetBasicInfoPopUp(false);
                                setPartyDetailesPopUp(false);
                                SetAttchmentAndDetailes(false);
                                SetTermsAndConditions(false);
                                SetW9Detailes(false);
                                SetEddDetailes(true);
                              }}
                              className="flex items-center text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                            >
                              <i className="gusd-check mr-1"></i>Next
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>

                {/* confirmation dialog */}

                <Dialog
                  header=""
                  visible={confirmVisible2}
                  style={{ width: "30vw" }}
                  onHide={() => {
                    setConfirmVisible2(false);
                    setVisibleEdit(false);
                  }}
                  footer={footerContent1}
                >
                  <p className="m-0 text-[#0487C8]">
                    <i className="pi pi-check-circle mr-2"></i>
                    <span className="font-medium text-[18px]">This report Has been Successfully Created</span>
                  </p>
                </Dialog>

                <div className="col-span-3 md:col-span-2 xl:col-span-3 2xl:col-span-3 sideBarRight openSideDiv">
                  <div className="h-full relative">
                    {/* <div className="text-[24px] xl:text-[1.250vw] font-medium">Report Details</div> */}
                    {/* <div className="mt-3 ml-3">
                      Reference No
                      <input
                        type="text"
                        name="name"
                        value={formData?.referenceNo}
                        placeholder="Type here"
                        onChange={e => {
                          formik.setFieldValue("referenceNo", e.target.value);
                        }}
                        // defaultValue={formik.values.typeBE}
                        className=" ml-3 bg-white border border-[#E4E7EC] rounded-[5px] xl:h-[2.292vw] h-[40px] xl:p-[0.625vw] p-[10px] placeholder:text-[#667085] placeholder:text-xs w-[109px] leading-10"
                      />
                    </div> */}

                    <div className="mt-[15px] lg:mt-[32px] xl:[1.667vw]">
                      {selectedEmployee ? (
                        <div className="bg-[#D8E7FC] border border-[#D8E7FC] grid grid-cols-12 gap-4">
                          <Avatar
                            className="col-span-3"
                            image="/images/avatar/amyelsner.png"
                            size="xlarge"
                            shape="circle"
                          />
                          <div className="col-span-7">
                            <label
                              className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                              for="username"
                            >
                              Name
                            </label>
                            <div className="text-[#101828] text-[12px] font-medium">
                              {selectedEmployeeDetails.employee_name}
                            </div>
                          </div>
                          <i className="gusd-edit col-span-2"></i>
                        </div>
                      ) : null}

                      <div className="absolute bottom-[20px] left-0 right-0 xl:bottom-[2.083vw] -z-[1]">
                        <img src={empDetailsImg} class=" mx-auto" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default PersonalsServiceagreementModal;
